/*  This is custom js file 
    to expand functional this theme
*/

(function($){

    var $ = jQuery = $;

    $(document).ready(function() {

        function pageFlyLinksA11y() {
            $('div[data-href][data-pf-type="Block"]').each(function() {
                var $div = $(this);
                var href = $div.attr('data-href');
                $div.wrap('<a class="m-wrapped-a"></a>').parent().attr('href', href);
            });
            $('div[data-href][data-pf-type="Column"]:not(.sc-fHeRUh.cCunWv.pf-345_)').each(function() {
                var $div = $(this);
                var href = $div.attr('data-href');
                var $parent = $div.closest('form');
                $parent.wrap('<a class="m-wrapped-a"></a>').parent().attr('href', href);
                if ($parent.length == 0) {
                    $div.wrap('<a class="m-wrapped-a"></a>').parent().attr('href', href);
                }
            });
        }

        $(document).on('click', '.m-title', function(e) {
            if ($(window).width() < 768) {
                $('.m-klarna').addClass('m-open')
                $('.m-overlay-klarna').addClass('m-open')
            }
        });

        $(document).on('click', '.m-title span', function(e) {
            if ($(window).width() > 768) {
                $('.m-klarna').addClass('m-desk-open')
            }
        });

        $(document).on('mouseleave', '.m-klarna.m-desk-open', function() {
            if ($(window).width() > 768) {
                $(this).removeClass('m-desk-open');
            }
        });

        $(document).on('click', '.js-options-close, .m-overlay-klarna', function(e) {
            if ($(window).width() < 768) {
                $('.m-klarna').removeClass('m-open')
                $('.m-overlay-klarna').removeClass('m-open')
            }
        });

        if ($('body').hasClass('template-index')) {
            pageFlyLinksA11y()
        }

        if ($.cookie('collectionGrid') == undefined) {
          $.cookie('collectionGrid', 'show-meta');
          $('body').addClass('show-meta');
        }

        if ($.cookie('collectionGrid') == 'show-meta') {
          $('body').addClass('show-meta');
        }

        if ($.cookie('collectionGrid') == 'no-data') {
           $('body').addClass('no-data')
        }

        if ($.cookie('collectionGrid') == 'four-per-row') {
           $('body').addClass('four-per-row')
        }
        $(document).on('keydown', 'body', function(e) {
            if (e.key == 'Escape' && $('.site-nav--is-megamenu').hasClass('is-focused')) {
                setTimeout(function() {
                    $('.site-nav--is-megamenu.is-focused').focus();
                },100);
                $('.site-nav--is-megamenu').removeClass('is-focused');
            }
        });
        
         $(document).on('click', '#grid-buttons button', function(e) {
            let button = $(this);
            if (button.attr('id') == "no-data") {
              $('body').addClass('no-data')
              $('body').removeClass('four-per-row show-meta')
              $.cookie('collectionGrid', 'no-data');
            }
            if (button.attr('id') == "show-meta") {
              $('body').addClass('show-meta');
               $('body').removeClass('no-data four-per-row');
               $.cookie('collectionGrid', 'show-meta');
            }
            if (button.attr('id') == "four-per-row") {
               $('body').removeClass('no-data show-meta')
               $('body').addClass('four-per-row');
               $.cookie('collectionGrid', 'four-per-row');
              }

           if ($(window).width() <= 768) {
             
              let marginMob = 20;
        
        		if($(window).width() > 500 && $(window).width() <= 768) {
        			marginMob = 55;
        		}
        
        		if($(window).width() < 500 ) {
        			marginMob = 45;
        		}
               setTimeout(function() {
                  // Button anchored via CSS bottom:0 inside image mask — no top calc needed
                  $('.js-prod-item .js-quick-add-cst').each(function() {
                      $(this).css({'opacity': 1});
                  });
              },100);
           } else {
              setTimeout(function() {
                 updateTopQuickAdd();
              },100)
           }
         });

         if($(".js-quick-filters-wrap").length && $(window).width() > 768) {
            $('.js-quick-filters').appendTo('.js-quick-filters-wrap');
          }

        $(window).scroll(function() {
            var height = $(window).scrollTop();
            if (height > 100) {
                $('#back2Top').fadeIn();
            } else {
                $('#back2Top').fadeOut();
            }
        });

        $("#back2Top").click(function(event) {
            event.preventDefault();
            $("html, body").animate({ scrollTop: 0 }, "slow");
            return false;
        });

        if ($(window).width() < 769) {
            $('#shipping-calculator h3').on('click', function(){
                $(this).closest("#shipping-calculator").toggleClass("m-open")
            });
        }
        
        $('.custom-name').on('click', function(){
            $(this).toggleClass("opened")
            if (!$(this).hasClass("opened")) {
                $(this).closest(".collection-sidebar__group").find(".collapsible-content--sidebar").removeClass("is-open").css("height","0")
                $(this).removeClass("is-open")
            } else {
                $(this).closest(".collection-sidebar__group").find(".collapsible-content--sidebar").addClass("is-open").css("height","auto")
                $(this).addClass("is-open")
            }
        });

        let prodPage = $(".product-single__meta").length,
            csTags = $(".tages-custom").length;
        if (prodPage && !csTags) {

            let sizeWrap = $(".variant-wrapper--button")
            $(document).on('click', '.variant__button-label', function(e) {
                var $label = $(this);
                var $fieldset = $label.closest('fieldset.variant-input-wrap');
                // Count available (non-disabled) options in this fieldset
                var $availableInFieldset = $fieldset.find('.variant__button-label').filter(function() {
                    return !$(this).closest('.variant-input').find('input[type="radio"]').prop('disabled');
                });
                // Only one available option — prevent deselection
                if ($label.hasClass('m-active') && $availableInFieldset.length === 1) { return; }
                // Deactivate all in fieldset, activate clicked label — ADA aria-pressed
                $fieldset.find('.variant__button-label').removeClass('m-active').attr('aria-pressed', 'false');
                $label.addClass('m-active').attr('aria-pressed', 'true');
                // Remove m-select-sz from ADD TO BAG once all fieldsets have a selection
                var allSelected = true;
                $('.variant-wrapper--button fieldset.variant-input-wrap').each(function() {
                    if (!$(this).find('.variant__button-label.m-active').length) { allSelected = false; }
                });
                if (allSelected) {
                    $('.payment-buttons .add-to-cart').removeClass('m-select-sz disabled').removeAttr('disabled');
                }
                // Show hide-btn and product inventory
                var sizeWrapInpt = $(".variant__button-label.m-active");
                if (sizeWrap.size() < 2) {
                    $(".hide-btn").addClass("m-show");
                } else if (sizeWrap.size() > 1) {
                    if (sizeWrapInpt.size() > 1) {
                        $(".hide-btn").addClass("m-show");
                    }
                }
                $(".product__inventory").addClass("m-show");
            });

            // variant-wrapper--button Std products (ONE-PIECE etc — no product-option-set)
            if ($('.variant-wrapper--button').length && !$('.product-option-set').length) {
                $('body').addClass('m-vbb-product');
                // ADA: aria-pressed on labels
                $('.variant__button-label').attr('aria-pressed', 'false');
                // Error span for ADA feedback
                if (!$('.m-size-error').length) {
                    $('.variant-wrapper--button').after('<span class="m-size-error" role="alert" aria-live="assertive" aria-hidden="true"></span>');
                }
                // Auto-select if only one available option exists
                var $vbbAvail = $('.variant-wrapper--button .variant__button-label').filter(function() {
                    return !$(this).closest('.variant-input').find('input[type="radio"]').prop('disabled');
                });
                if ($vbbAvail.length === 1) {
                    setTimeout(function() { $vbbAvail.first().trigger('click'); }, 300);
                }
                // ADD TO BAG feedback when no size selected
                $(document).on('click', '.m-vbb-product .payment-buttons .add-to-cart.m-select-sz', function(e) {
                    e.preventDefault();
                    $('.variant-wrapper--button').addClass('m-size-shake');
                    setTimeout(function() { $('.variant-wrapper--button').removeClass('m-size-shake'); }, 600);
                    var $errEl = $('.m-size-error');
                    $errEl.text('Please select a size').attr('aria-hidden', 'false');
                    setTimeout(function() { $errEl.text('').attr('aria-hidden', 'true'); }, 3000);
                });
            }

        }
        let $minHeight = 61,
            rteContainer = $('#CollectionSection .rte.dscr')
        if (rteContainer.length) {
            let rteP = rteContainer.find("p"),
                rtePfirst = rteContainer.find("p:first-child");
            if ( rteP.length > 1 && rtePfirst.height() >= $minHeight) {
                rteContainer.addClass("m-full");
                $(".show-more__rte").show()
            }
            $(document).on('click', '.show-more__rte', function(e) {
                e.preventDefault()
                if (rteContainer.hasClass("m-full")) {
                    rteContainer.removeClass("m-full")
                    $(this).addClass("m-opened")
                } else {
                    rteContainer.addClass("m-full")
                    $(this).removeClass("m-opened")
                }
            });
        }

        $(document).on('click', '.prod-accor__title', function(e) {
            let titleAccor = $(this),
                contentAccor = $(this).siblings(".prod-accor__content");
            contentAccor.slideToggle()
            titleAccor.toggleClass("is-active")
        });

// FENSONS: EXPANDER BLOCKS
        
        $(document).ready(function() {
          $('.expander').each(function() {
            let dataMaxHeight = +($(this).attr('data-max-height'));
            
            $(this).wrap('<div class="expander-outer"></div>');
            $(this).wrap('<div class="expander-wrap"></div>');
            
            var collapseTrigger = $('<div class="expander-collapse-trigger"><span></span></div>');
            $(this).parent('.expander-wrap').after(collapseTrigger);
            $(this).removeClass('m-temp-until-load');

            $('.expander-wrap').css('max-height', dataMaxHeight + 'px')
          });
        });
        
        $(document).on('click', '.expander-collapse-trigger span', function(e) {
            let closestWrap = $(this).closest('.expander-outer');
            let closestExpanderWrap = closestWrap.find('.expander-wrap');
            let closestExpander = closestWrap.find('.expander');
            let dataMaxHeight = +(closestExpander.attr('data-max-height'));
            let height = closestExpander.outerHeight();
            let maxHeight = dataMaxHeight;
            height = height + 20;
            if ($(window).width() > 980) {
                maxHeight = dataMaxHeight;
            } else {
                maxHeight = dataMaxHeight;
            }
            closestWrap.toggleClass('m-full');
            if (closestWrap.hasClass('m-full')) {
                closestExpanderWrap.css('max-height', height + 'px')
            } else {
                closestExpanderWrap.css('max-height', maxHeight + 'px')
            }
        });
        
// END FENSONS: EXPANDER BLOCKS

// FENSONS: FAQ FREQUENTLY ASKED QUESTIONS
         $(document).ready(function() {
            $('.faq-q').click(function() {
              $(this).toggleClass('faq-active');
              $(this).next('.faq-a').slideToggle();
            });
          });
// END FENSONS: FAQ FREQUENTLY ASKED QUESTIONS

// FENSONS: APPLY CLASS TO ANCHOR TAG WITH SAME URL AS CURRENT PAGE URL
        $(document).ready(function() {
            var baseUrl = window.location.origin;
            var currentUrl = window.location.href;
        
            // Extract the base URL of the current collection
            var pathName = window.location.pathname; // Gets the path segment of the URL
        
            $('#view-all').attr('href', baseUrl + pathName); // Set the href of the View All link
        
            var $collectionQuickFilters = $('.collection-quick-filters');
            var $viewAll = $('#view-all');
            var $currentAnchor = null;
        
            // Function to normalize an href to an absolute URL
            function normalizeHref(href) {
                if (href.startsWith('http')) {
                    return href; // Already absolute URL
                } else {
                    return baseUrl + (href.startsWith('/') ? '' : '/') + href;
                }
            }
        
            $collectionQuickFilters.find('a').each(function() {
                var anchorHref = normalizeHref($(this).attr('href'));
                if (anchorHref === currentUrl) {
                    $currentAnchor = $(this);
                    $(this).addClass('currenturl');
                    return false; // Exit the loop once the current anchor is found
                }
            });
        
            // Check if the screen width is 768px or less
            if ($(window).width() <= 768) {
                if ($currentAnchor) {
                    $currentAnchor.insertAfter($viewAll); // Move the current anchor right after the View All link on mobile screens
                }
            }
        
            // RESET button for the QUICK FILTER
            var $resetQuickFilter = $('#reset-quick-filter');
            if (currentUrl.includes('?')) {
                $resetQuickFilter.show();
            }
        
            $resetQuickFilter.click(function(event) {
                event.preventDefault();
                window.location.href = baseUrl + pathName;
            });
        });





// END FENSONS: apply class to anchor tag with same url as current page url

        // $(document).on('click', '.diffsize', function(e) {
        //     e.preventDefault()
        //     $(".size-f").addClass('m-opened')
        // });

        $(document).on('click', '.price-match-trigger', function(e) {
            e.preventDefault()
            $(".price-f").addClass('m-opened')
        });

        $(document).on('click', '.product-form__popup-close', function() {
            $(this).closest(".product-form__popup").removeClass('m-opened')
        });

        $(document).on('click', '.product-form__popup-close', function() {
            $(this).closest(".product-form__popup").removeClass('m-opened')
        });

        var playerIsPaused = true;

        $(document).on('click', '.js-slick-video', function() {
            let thumb = $(this),
                video = thumb.closest('.product__photos').find('.js-video-m video');
            setTimeout(function(){
                if (thumb.hasClass('slick-active') && $('.js-video-m').hasClass('m-true')) {
                    video.get(0).play();
                    playerIsPaused = false;
                    $('.js-video-m').addClass('m-true');
                } else {
                    video.get(0).pause();
                    playerIsPaused = true;
                    $('.js-video-m').removeClass('m-true');
                }
            }, 500);
        });

        // $(document).on('click', '.js-video-m', function() {
        //     let videoWrap = $(this),
        //         video = videoWrap.find('video');
        //     if (videoWrap.hasClass('slick-active') && playerIsPaused == true && $('.js-video-m').hasClass('m-true')) {
        //         video.get(0).play();
        //         playerIsPaused = false;
        //         $('.js-video-m').removeClass('m-true')
        //     } else {
        //         video.get(0).pause();
        //         playerIsPaused = true;
        //         $('.js-video-m').addClass('m-true');
        //     }
        // });

        $(document).on('click', '.acct-act-header', function() {
            let slideWrap = $('.under-act-wrap');
            slideWrap.toggleClass('m-expand')
            $(this).toggleClass('m-expand')
            if (slideWrap.hasClass('m-expand')) {
                slideWrap.slideDown();
            } else {
                slideWrap.slideUp();
            }
        });

        if (!$('body').hasClass('template-product')) {
            setTimeout(function() {
                $(".grid-overflow-wrapper-s").addClass('grid-overflow-wrapper');
            }, 1500);

        }

        if ($('body').hasClass('template-product') && $(window).width() <= 500) {
            setTimeout(function() { 
                $(".template-product").addClass('m-loaded');
            }, 1500);
        }

        function settingUniqIdToSet() {
            let randowubmer = Math.floor(Math.random() * 16 * 2 + 3),
            prodId = $('.js-uniq').data('prod-id'),
            uniqNubmer = randowubmer + prodId;
            $('.js-uniq').val(uniqNubmer);
            $('.js-uniq').trigger('change');
        }
   
        if ($('body').hasClass('template-product') && $('.product-option-set').hasClass('js-group')) {

            settingUniqIdToSet()

            $(document).on('submit', '.product-single__form', function(e) {
                settingUniqIdToSet()
            });
        }

      /* custom scrollbar */
        let recentlyWrapper = ".recently-viewed .grid-overflow-wrapper-s",
        scrollBarHorizontalOptions = {
            axis:"x",
            theme:"dark-thin",
            autoExpandScrollbar:true,
            alwaysShowScrollbar:false,
            autoHideScrollbar: true,
            scrollInertia:550, 
            advanced:{ 
                updateOnContentResize: true 
            }
        },
        scrollBarVerticalOptions = {
            axis:"y",
            theme:"dark-thin",
            autoExpandScrollbar:true,
            alwaysShowScrollbar:false,
            autoHideScrollbar: true,
            scrollInertia:550, 
            advanced:{ 
                updateOnContentResize: true 
            }
        };

        if ($('body').hasClass('template-collection')) {
            if ($(window).width() > 992) {
                setTimeout(function(){
                    $(recentlyWrapper).mCustomScrollbar(scrollBarVerticalOptions);
                }, 1000)
            }
    
            $(window).resize( function() {
                if ($(window).width() > 992) {
                    $(recentlyWrapper).mCustomScrollbar(scrollBarVerticalOptions);
                } else {
                    $(recentlyWrapper).mCustomScrollbar('destroy'); 
                } 
            })
        } 

        $('.product-single__variants option').each(function(index,value) {
            if ($(value).attr('data-css') == 'Out of stock') {
              $('.size-chart-and-links .diffsize').addClass('m-size-show')
            }
            if ( $('.product-opt__select[data-name="Select"]').length) {
                $('.product-opt__select[data-name="Select"]').each(function(ind,select) {
                    $(select).find('ul[data-position="2"] .product-opt__btn').each(function(ind,val) {

                        if ($(value).attr('data-option1') === $(val).attr('data-option1') &&
                            $(value).attr('data-option2') === $(val).attr('data-option2') &&
                            $(value).attr('data-css') != 'Out of stock') {
                                $(val).removeClass('product-opt__btn_none');
                                $(val).removeAttr("disabled");
                                if ($(select).find('.product-opt__select-price').hasClass('product-opt__select-price_none')) {
                                    let fullPrice = $(value).attr('data-compare_at_price');
                                    let currentPrice = $(value).attr('data-price');
                                    $(select).find('.product-opt__select-price').removeClass('product-opt__select-price_none');
                                   if (fullPrice) {  // truthy check for non-empty string
                                        $(`<span class="product-opt__full-price">${fullPrice}</span>`)
                                        .appendTo(`.product-opt__select[value="${$(value).attr('data-option1')}"] .product-opt__select-price`);

                                        $(`<span class="product-opt__current-price">${currentPrice}</span>`)
                                        .appendTo(`.product-opt__select[value="${$(value).attr('data-option1')}"] .product-opt__select-price`);

                                        // Inject per-row sale badge using Liquid-computed percent-off
                                        let pct = $(value).attr('data-percent-off');
                                        if (pct) {
                                            $(`<span class="product-opt__sale-badge">-${pct}%</span>`)
                                            .appendTo(`.product-opt__select[value="${$(value).attr('data-option1')}"] .product-opt__select-price`);
                                        }
                                    } else {
                                        $(`<span>${currentPrice}</span>`)
                                        .appendTo(`.product-opt__select[value="${$(value).attr('data-option1')}"] .product-opt__select-price`);
                                    }
                                }
                        }
                    })
                })
            }
        });

        let firstVariant = '-';
        let secondVariant = '-';
        let btnActive = {
            bottomPosition2:'-',
            bottomPosition3:'-',
            topPosition2:'-',
            topPosition3:'-'
        };

        function resetButtonValues() {
            $.each(btnActive, function(key,value) {
                key = '-';
            })
        }

        function clearSelect() {
            $('.product-single__variants option').each(function(index,val) {
                $(val).removeAttr("selected");
                $(val).prop('selected', false);
            });
        }

        function shooseOption(value) {
            $(value).prop('selected', true);
            $(value).attr('selected', 'selected');
        }

        function removeOption(value) {
            $(value).removeAttr("selected");
            $(value).prop('selected', false);
        }

        function clearBtnSize() {
            $('.product-option-set .product-opt__btn').each(function(index,value) {
                if($(value).hasClass('product-opt__btn_active')) {
                    $(value).removeClass('product-opt__btn_active');
                }
            });
        }

        function disableAddToCart() {
            if ($('.payment-buttons .add-to-cart').not('m-select-sz') ) {
                $('.js-original-button-text-top').css({display:'none'});
                $('.js-original-button-text-bottom').css({display:'none'});
                $('.js-choose-option').css({display:'inline'});
                $('.js-original-button-text-both').css({display:'none'});
                $('.payment-buttons .add-to-cart').addClass('m-select-sz');
            }
        }

        function activateAddToCart() {
                    if(firstVariant != '-' && secondVariant != '-') {
                        if($('.js-original-button-text-both').css('display') == 'none'){
                            $('.js-original-button-text-top').css({display:'none'});
                            $('.js-original-button-text-bottom').css({display:'none'});
                            $('.js-choose-option').css({display:'none'});
                            if($('.page-content--product').length) {
                                let variants = $('.product-opt__btn_active');
                                let cssRule = '';
                                variants.each(function() {
                                    let variantId = $(this).attr('data-id');
                                    let variantCssRule = $(`.product-single__variants option[value="${variantId}"]`).attr('data-css_rule');
                                    if (variantId != undefined) {
                                        if(variantCssRule.indexOf('PREORDER')+1 > 0 ) {
                                            cssRule = variantCssRule;
                                        };
                                    }
                                });
                                if (cssRule != undefined) {
                                    if(cssRule.indexOf('PREORDER')+1 > 0 ){
                                        $('.js-original-button-text-both').text(`PREORDER BOTH TOP AND BOTTOM`)
                                    } else {
                                        $('.js-original-button-text-both').html(`add both to bag`)
                                    }
                                }
                            } else {
                                setTimeout(function() {
                                    let productId = ($('.custom-mobile-qv-p').attr('data-prod-id'));
                                    let product = $(`.js-prod-item[data-id="${productId}"]`);
                                    let variantId = '';
                                    let cssRule = '';
                                    $('.js-quick-vr').each(function() {
                                        if(!!$(this).attr('data-vr')){
                                            variantId = $(this).attr('data-vr');
                                        }
                                    })
                                    cssRule = $(product).find(`[data-variant-id="${variantId}"]`).attr('data-variant-css');
                                    if (cssRule != undefined) {
                                        if(cssRule.indexOf('PREORDER')+1 > 0 ){
                                            $('.js-original-button-text-both').text(`PREORDER BOTH TOP AND BOTTOM`)
                                        } else {
                                            $('.js-original-button-text-both').html(`add both to bag`)
                                        }
                                    }
                                },500);
                                // (Removed dead Conversion Bear price-injection — app no longer installed)
                                // $('.js-original-button-text-both').html(`add both to bag`)
                                // $('.js-original-button-text-both').html(`add both to bag - ${$('.product-single__variants').attr('data-full_price')}`)
                            }
                            $('.js-original-button-text-both').css({display:'inline'});

                            if ($('.payment-buttons .add-to-cart').hasClass('m-select-sz') || $('.payment-buttons .add-to-cart').hasClass('disabled')) {
                                $('.payment-buttons .add-to-cart').removeClass('m-select-sz disabled');
                                $('.payment-buttons .add-to-cart').removeAttr("disabled");
                            }
                        }
                    } else {
                        if(firstVariant != '-') {
                            if($('.js-original-button-text-top').css('display') == 'none') {
                                let price = $(firstVariant).text().split('-');
                                $('.js-original-button-text-both').css({display:'none'});
                                $('.js-original-button-text-bottom').css({display:'none'});
                                $('.js-choose-option').css({display:'none'});
                                if($('.page-content--product').length) {
                                    let variantId = $('.product-opt__btn_active').attr('data-id');
                                    let cssRule = $(`.product-single__variants option[value="${variantId}"]`).attr('data-css_rule');
                                    if(cssRule.indexOf('PREORDER')+1 > 0 ){
                                        $('.js-original-button-text-top').text(`PREORDER TOP`)
                                    } else {
                                        $('.js-original-button-text-top').text(`add top to bag`)
                                    }
                                } else {
                                    setTimeout(function() {
                                        let productId = ($('.custom-mobile-qv-p').attr('data-prod-id'));
                                        let product = $(`.js-prod-item[data-id="${productId}"]`);
                                        let variantId = '';
                                        let cssRule = '';
                                        $('.js-quick-vr').each(function() {
                                            if(!!$(this).attr('data-vr')){
                                                variantId = $(this).attr('data-vr');
                                            }
                                        })
                                        cssRule = $(product).find(`[data-variant-id="${variantId}"]`).attr('data-variant-css');
                                        if (cssRule != undefined) {
                                            if(cssRule.indexOf('PREORDER')+1 > 0 ){
                                                $('.js-original-button-text-top').text(`PREORDER TOP`)
                                            } else {
                                                $('.js-original-button-text-top').text(`add top to bag`)
                                            }
                                        }
                                    },500);
                                    // $('.js-original-button-text-top').text(`add top to bag`)
                                    // $('.js-original-button-text-top').text(`add top to bag - ${price[price.length - 1]}`)
                                }
                                $('.js-original-button-text-top').css({display:'inline'});
                            }

                            if ($('.payment-buttons .add-to-cart').hasClass('m-select-sz') || $('.payment-buttons .add-to-cart').hasClass('disabled')) {
                                $('.payment-buttons .add-to-cart').removeClass('m-select-sz disabled');
                                $('.payment-buttons .add-to-cart').removeAttr("disabled");
                            }
                        } 
                        if(secondVariant != '-')  {
                            if($('.js-original-button-text-bottom').css('display') == 'none') {
                                let price = $(secondVariant).text().split('-');
                                $('.js-original-button-text-top').css({display:'none'});
                                $('.js-original-button-text-both').css({display:'none'});
                                $('.js-choose-option').css({display:'none'});
                                if($('.page-content--product').length) {
                                    let variantId = $('.product-opt_block_3 .product-opt__btn_active').attr('data-id');
                                    if (variantId == undefined) {
                                        variantId = $('.product-opt_block_2 .product-opt__btn_active').attr('data-id');
                                    }
                                    let cssRule = $(`.product-single__variants option[value="${variantId}"]`).attr('data-css_rule');
                                    if(cssRule.indexOf('PREORDER')+1 > 0 ){
                                        $('.js-original-button-text-bottom').text(`PREORDER BOTTOM`)
                                    } else {
                                        $('.js-original-button-text-bottom').text(`add bottom to bag`)
                                    }
                                } else {
                                    setTimeout(function() {
                                        let productId = ($('.custom-mobile-qv-p').attr('data-prod-id'));
                                        let product = $(`.js-prod-item[data-id="${productId}"]`);
                                        let variantId = '';
                                        let cssRule = '';
                                        $('.js-quick-vr').each(function() {
                                            if(!!$(this).attr('data-vr')){
                                                variantId = $(this).attr('data-vr');
                                            }
                                        })
                                        cssRule = $(product).find(`[data-variant-id="${variantId}"]`).attr('data-variant-css');
                                        if(cssRule.indexOf('PREORDER')+1 > 0 ){
                                            $('.js-original-button-text-bottom').text(`PREORDER BOTTOM`)
                                        } else {
                                            $('.js-original-button-text-bottom').text(`add bottom to bag`)
                                        }
                                    },500);
                                    // $('.js-original-button-text-bottom').text(`add bottom to bag`)
                                    // $('.js-original-button-text-bottom').text(`add bottom to bag - ${price[price.length - 1]}`)
                                }
                                $('.js-original-button-text-bottom').css({display:'inline'});
                            }

                            if ($('.payment-buttons .add-to-cart').hasClass('m-select-sz') || $('.payment-buttons .add-to-cart').hasClass('disabled')) {
                                $('.payment-buttons .add-to-cart').removeClass('m-select-sz disabled');
                                $('.payment-buttons .add-to-cart').removeAttr("disabled");
                            }
                        }
                        if(firstVariant === '-' && secondVariant === '-') {
                            disableAddToCart();
                        }
                    }
        }

        function actionRadioInput(value) {
            $('.product-opt__select').each(function(index,select) {
                if($(select).attr('value') === $(value).attr('data-option1')) {
                    $(`.product-opt__select[value='${$(value).attr('data-option1')}'] .product-opt__input`).each(function(index,radioInput) {
                        if($(value).attr('data-option1') === $(radioInput).attr('value')){
                            $(radioInput).trigger('click');
                        }
                        if($(value).attr('data-option2') === $(radioInput).attr('value')){
                            $(radioInput).trigger('click');
                        }
                        if($(value).attr('data-option3') === $(radioInput).attr('value')){
                            $(radioInput).trigger('click');
                        }
                        if($(value).attr('data-option3') === '-' && $(radioInput).attr('data-index') === 'option3'){
                            $(radioInput).trigger('click');
                        }
                    });
                }
            })
        }

        function addTooltipVariant(addClass,value) {
          	if($(`.${addClass} .product-opt__final-sale`).length) {
                $(`.${addClass} .product-opt__final-sale`).remove();
            }
            if($(`.${addClass}`).find('.product-opt__inventory').hasClass('product-opt__inventory_show')) {
                $(`.${addClass}`).find('.product-opt__inventory').removeClass('product-opt__inventory_show');
            }
        
            let variableCss = $(value).attr('data-css');
            $('.css-drawer').val(variableCss);
            $(`.${addClass} .css-status-msg`).text(variableCss);
            let variantProduct = $(value).attr('value');
            let tooltipContentSet = false;
            $('.tooltip__variants .tooltip__variant').each(function(index,value) {
                if(variantProduct === $(value).attr('value')) {
                    $(value).closest(`.${addClass} .tooltip`).removeClass('tooltip__instock');
                    let variableCssTooltip = $(value).attr('data-css');
                    let instock = $(value).attr('data-quantity');
                    if ( instock === 'instock') {
                        $(value).closest(`.${addClass} .tooltip`).addClass('tooltip__instock');
                    } else {
                        $(`.${addClass} .tooltip__css-status-msg`).html(variableCssTooltip);
                        tooltipContentSet = true;
                    }
                }
            });
            // QV fallback: reconstruct rule-specific tooltip HTML from the short status text
            var hasTooltipContent = variableCss && variableCss.trim() !== '' && variableCss !== 'In stock' && variableCss !== 'Out of stock';
            // Scope to the active desktop QV card only — prevents body-panel duplicate from bleeding in
            var $qvCtx = $('.grid__item.m-selected .custom-mobile-qv-p');
            var $tooltipWrap = $qvCtx.length ? $qvCtx.find('.qv-tooltip-wrap') : $('.qv-tooltip-wrap');
            if (!tooltipContentSet && hasTooltipContent) {
                var expressNote = '<p style="border-top: 1px dotted #666; padding-top: 10px;"><strong>What if I select EXPRESS shipping?</strong><br>Doing so does not change the processing time indicated, but will speed up delivery once shipped.</p>';
                var tooltipHtml;
                if (variableCss.indexOf('Processed within') !== -1) {
                    tooltipHtml = '<p style="font-size: 1.1em;">Item is expected to be ' + variableCss.toLowerCase() + '.</p>' + expressNote;
                } else if (variableCss.indexOf('Ships from week of') !== -1) {
                    tooltipHtml = '<p style="font-size: 1.1em;">Item is expected to be shipped from week of ' + variableCss.replace('Ships from week of ', '') + '.</p>' + expressNote;
                } else {
                    tooltipHtml = '<p>' + variableCss + '</p>';
                }
                $tooltipWrap.find('.tooltip__css-status-msg').html(tooltipHtml);
            }
            // Show/hide the QV "What does this mean?" button and reposition it inside
            // the active css-status span, above the ships_from_country span
            if (hasTooltipContent) {
                var $cssStatus = $qvCtx.length ? $qvCtx.find('.' + addClass) : $(`.${addClass}`);
                // Reposition the tooltip wrap inside the css-status box so "What does
                // this mean?" sits directly under the "Processed within..." text — on
                // both desktop (clone) and mobile (body panel).
                // On mobile the wrap is rescued back to .qv-add-to-cart on QV close
                // (see .qv-product-title click handler) before the options list is wiped.
                if ($cssStatus.length && $tooltipWrap.length) {
                    var $shipsFrom = $cssStatus.find('.ships_from_country');
                    if ($shipsFrom.length) {
                        $tooltipWrap.insertBefore($shipsFrom);
                    } else {
                        $tooltipWrap.appendTo($cssStatus);
                    }
                }
                $tooltipWrap.find('.js-tooltip').removeClass('m-tool-hide');
            } else {
                $tooltipWrap.find('.js-tooltip').addClass('m-tool-hide');
            }
          	$('.m-variants-sale .m-variant-sale').each(function(index,variantSale) {
                if($(variantSale).attr('data-vr-id') === variantProduct) {
                    $(`.${addClass}`).append(`<div class='product-opt__final-sale'>${$(variantSale).children().attr('value')}</div>`)
                }
            });
            var $shipsSpan = $(`.${addClass} .ships_from_country`);
            if ($shipsSpan.length) {
                var shipsFromCountry = $(value).attr('data-ships-from-country');
                var invQty = parseInt($(value).attr('data-inventory-quantity') || '0', 10);
                var $meta = $('.product-single__form .js-form-intl-ddu, .qv-add-to-cart .js-form-intl-ddu').first();
                var metaCurrency = $meta.attr('data-currency');
                var metaIntlDdu = $meta.attr('data-intl-ddu');
                var isUs = metaCurrency === 'USD';
                var hasTag = metaIntlDdu === 'true';
        
                if (isUs && hasTag && invQty < 1 && shipsFromCountry) {
                    var shipsText = 'Ships from ' + shipsFromCountry + '. May be subject to customs/tariffs.';
                    $shipsSpan.text(shipsText).css('opacity', 1);
                    $('.ships-from-country-drawer').val(shipsText);
                } else {
                    $shipsSpan.css('opacity', 0).text('');
                    $('.ships-from-country-drawer').val('');
                }
            }
            // Read inventory directly from the selected variant option so the message
            // is variant-specific and shows instantly without a timeout.
            var varInvQty = parseInt($(value).attr('data-inventory-quantity') || '0', 10);
            if (varInvQty === 1) {
                $(`.${addClass}`).find('.product-opt__inventory').addClass('product-opt__inventory_show');
            } else {
                $(`.${addClass}`).find('.product-opt__inventory').removeClass('product-opt__inventory_show');
            }
                $(`.${addClass}`).removeClass('m-hide-css').addClass('m-show');
        }

        function hideTooltipVariant(addClass) {
            $(`.${addClass}`).addClass('m-hide-css').removeClass('m-show');
          	$(`.${addClass}`).find('.product-opt__inventory').removeClass('product-opt__inventory_show');
            var $qvCtxH = $('.grid__item.m-selected .custom-mobile-qv-p');
            var $twH = $qvCtxH.length ? $qvCtxH.find('.qv-tooltip-wrap') : $('.qv-tooltip-wrap');
            $twH.find('.js-tooltip').addClass('m-tool-hide');
        }

        function updateDrawerFromOption(optionEl) {
            var $opt = $(optionEl);
            var variableCss = $opt.attr('data-css') || '';
            $('.css-drawer').val(variableCss);
            var shipsFromCountry = $opt.attr('data-ships-from-country');
            var invQty = parseInt($opt.attr('data-inventory-quantity') || '0', 10);
            var isUs = $('.product-single__form .js-form-intl-ddu').attr('data-currency') === 'USD';
            var hasTag = $('.product-single__form .js-form-intl-ddu').attr('data-intl-ddu') === 'true';
            var shipsText = (isUs && hasTag && invQty < 1 && shipsFromCountry) ? ('Ships from ' + shipsFromCountry + '. May be subject to customs/tariffs.') : '';
            $('.ships-from-country-drawer').val(shipsText);
        }

        if ($('.product-option-set').length) {

            $('.payment-buttons .add-to-cart').append('<span class="product-opt__wrapper"></span>');

            function addWrapperWishlist() {
                if ($('.swym-button-bar').length && $('.swym-button-bar__wrapper').length < 1) {
                    $('.swym-button-bar').append('<span class="swym-button-bar__wrapper"></span>');
                }
                setTimeout(function() {
                    addWrapperWishlist();
                },2000)
            }
            addWrapperWishlist();
    
            // FIX: was setTimeout(..., 2000) which left a 2s race where
            // addTooltipVariant('.css-status__top|bottom .css-status-msg') had
            // nothing to match against — clicks in that window populated no
            // status text until a second click after the timeout fired. Apply
            // the classes immediately on ready so the status writes on first click.
            $($('.css-status')[0]).addClass('css-status__top').addClass('m-hide-css');
            $($('.css-status')[1]).addClass('css-status__bottom').addClass('m-hide-css');

            function resetButton() {
                if(firstVariant === '-' && secondVariant === '-'){
                    disableAddToCart();
                }
                setTimeout(function() {
                    resetButton();
                },2000)
            }
            resetButton();

            // Removed 2026-05-15: $('.product__price .conversion-bear-money').parent().remove();
            // Was a hotfix for the Conversion Bear app; app is no longer installed
            // and the .conversion-bear-money wrappers are no longer emitted by the
            // theme (see product-template.liquid, product-form.liquid, section-other-items.liquid).
            $('.m-variants-sale').css({display:'none'});
            $('.product__inventory').css({opacity:'0', height:'0px'});
            $('.payment-buttons .add-to-cart').append('<span class="js-original-button-text-top" style="display:none">add top to bag</span>');
            $('.payment-buttons .add-to-cart').append('<span class="js-original-button-text-bottom" style="display:none">add bottom to bag</span>');
            $('.payment-buttons .add-to-cart').append('<span class="js-original-button-text-both" style="display:none">add both to bag</span>');

            // ADA: initialise aria-pressed on all size buttons
            $('.product-option-set .product-opt__btn').attr('aria-pressed', 'false');

            // Std (non-set) product setup — exclude grouped and grouped-fits products (Top optional, Bottom-only purchase allowed)
            if (!$('.product-option-set').hasClass('js-group') && !$('body').hasClass('prod-type-grouped-fits') && !$('body').hasClass('prod-type-grouped')) {
                $('body').addClass('m-std-product');
                // Error region for screen readers and visual feedback
                if (!$('.m-size-error').length) {
                    $('.product-option-set').after('<span class="m-size-error" role="alert" aria-live="assertive" aria-hidden="true"></span>');
                }
                // Auto-select when only one size is available (e.g. ONE SIZE)
                var $stdAvailBtns = $('.product-option-set .product-opt__btn:not(.product-opt__btn_none):not([disabled])');
                if ($stdAvailBtns.length === 1) {
                    setTimeout(function() { $stdAvailBtns.first().trigger('click'); }, 300);
                }
            }
        }

        $(document).on('click', 'body:not(.template-collection) .product-option-set .product-opt__btn', function(e) {
            e.preventDefault();
            let btn = this;

            $('.product-single__variants option').each(function(index,value) {
            
                if ($(value).attr('data-option3') === '') {
                    $(value).attr('data-option3', '-')
                }

                if ($(value).attr('data-option3') != '-'&&
                    $(value).attr('data-option1') === $(btn).attr('data-option1') && 
                    $(value).attr('data-option2') === $(btn).attr('data-option2')) {

                        if ($(btn).attr('data-option1') === 'Bottom') {
                            let attr = $(btn).attr('data-option3');
                            if (typeof attr !== typeof undefined && attr !== false) {
                                if($(value).attr('data-option1') === $(btn).attr('data-option1') && $(value).attr('data-option2') === $(btn).attr('data-option2') && $(value).attr('data-option3') === $(btn).attr('data-option3')) {
                                    let val = btn;
                                    $('.product-single__variants option').each(function(index,value) {
                                        if ($(value).attr('data-option3') != '-' && $(value).attr('selected') === 'selected') {
                                            removeOption(value);
                                        }
                                    })
                                    $(val).closest('ul[data-position="3"]').find('.product-opt__btn').each(function(index,btnPosition3) {
                                        if ($(btnPosition3).hasClass('product-opt__btn_active')) {
                                            $(btnPosition3).removeClass('product-opt__btn_active');
                                        }
                                        setTimeout(function() {
                                            activateAddToCart();
                                        },200)
                                    
                                    })
                                        $(val).addClass('product-opt__btn_active');
                                        $(val).attr('data-id',`${$(value).attr('value')}`);
                                        shooseOption(value);
                                        secondVariant = value;
                                        btnActive.bottomPosition3 = $(this).attr('data-option3');
                                        addTooltipVariant('css-status__bottom',value);
                                        setTimeout(function() {
                                            actionRadioInput(value);
                                        },200)
                                }
                            } else {
                                $(btn).closest('ul[data-position="2"]').find('.product-opt__btn').each(function(index,btnPosition2) {
                                    $('.product-single__variants option').each(function(index,value) {
                                        if ($(value).attr('data-option3') != '-' && $(value).attr('selected') === 'selected') {
                                            removeOption(value);
                                        }
                                    });
        
                                    if($(btnPosition2).hasClass('product-opt__btn_active')) {
                                        $(btnPosition2).removeClass('product-opt__btn_active');
                                    }
    
                                    if($(btn).attr('data-option2') === $(btnPosition2).attr('data-option2')) {
                                        if($('.css-status__bottom').not('m-hide-css')) {
                                            hideTooltipVariant('css-status__bottom');
                                        }
            
                                        if ($('.payment-buttons .add-to-cart').not('m-select-sz') && $(firstVariant).attr('selected') != 'selected' ) {
                                            disableAddToCart();
                                        }
            
                                        $(btnPosition2).closest('.product-opt__select[data-position="1"]').find('ul[data-position="3"] .product-opt__btn').each(function(index,btnPosition3) {
                                            $(btnPosition3).removeAttr('data-option2');
                                            if ($(btnPosition3).hasClass('product-opt__btn_active')) {
                                                $(btnPosition3).removeClass('product-opt__btn_active');
                                                secondVariant = '-';
                                                activateAddToCart();
                                            }
                                        })
                                        if(btnActive.bottomPosition2 === $(btnPosition2).attr('data-option2')) {
                                            setTimeout(function() {
                                                btnActive.bottomPosition2 = '-';
                                                btnActive.bottomPosition3 = '-';
                                                $(btnPosition2).removeClass('product-opt__btn_active');
                                                if($('.css-status__bottom').not('m-hide-css')) {
                                                    hideTooltipVariant('css-status__bottom');
                                                }
                                                // Hide FIT block when bottom size is deselected
                                                $(btnPosition2).closest('.product-opt__select[data-position="1"]').find('ul[data-position="3"]').addClass('product-opt_block_none');
                                            },200)
                                        } else {
                                            $(btnPosition2).closest('.product-opt__select[data-position="1"]').find('ul[data-position="3"] .product-opt__btn').each(function(index,btnPosition3) {
                                                $(btnPosition3).attr('data-option2', `${$(btnPosition2).attr('data-option2')}`);
                                            })
                                            setTimeout(function() {
                                                btnActive.bottomPosition2 = $(btnPosition2).attr('data-option2');
                                                $(btnPosition2).addClass('product-opt__btn_active');
                                            },200)
                                        }
                                    }
                                })

                                if ($(btn).closest('.product-opt__select[data-position="1"]').find('ul[data-position="3"]').hasClass('product-opt_block_none')) {
                                    $(btn).closest('.product-opt__select[data-position="1"]').find('ul[data-position="3"]').removeClass('product-opt_block_none');
                                }

                                $(btn).closest('.product-opt__select[data-position="1"]').find('ul[data-position="3"] .product-opt__btn').each(function(ind,val) {
                                    $(val).attr("disabled",true);
                                    $(val).addClass('product-opt__btn_none');

                                    if ($(value).attr('data-option1') === $(val).attr('data-option1') && $(value).attr('data-option3') === $(val).attr('data-option3') && $(value).attr('data-css') != 'Out of stock') {
                                        setTimeout(function() {
                                            $(val).removeAttr("disabled");
                                            $(val).removeClass('product-opt__btn_none');
                                        },200)
                                    }
                                })
                            }
    
                        }

                        if ($(btn).attr('data-option1') === 'Top') {
                            let attr = $(btn).attr('data-option3');
                            if (typeof attr !== typeof undefined && attr !== false) {
                                if($(value).attr('data-option1') === $(btn).attr('data-option1') && $(value).attr('data-option2') === $(btn).attr('data-option2') && $(value).attr('data-option3') === $(btn).attr('data-option3')) {
                                    let val = btn;
                                    $('.product-single__variants option').each(function(index,value) {
                                        if ($(value).attr('data-option3') != '-' && $(value).attr('selected') === 'selected') {
                                            removeOption(value);
                                        }
                                    })
                                    $(val).closest('ul[data-position="3"]').find('.product-opt__btn').each(function(index,btnPosition3) {
                                        if ($(btnPosition3).hasClass('product-opt__btn_active')) {
                                            $(btnPosition3).removeClass('product-opt__btn_active');
                                        }
                                        setTimeout(function() {
                                            activateAddToCart();
                                        },200)
                                    
                                    })
                                        $(val).addClass('product-opt__btn_active');
                                        $(val).attr('data-id',`${$(value).attr('value')}`);
                                        shooseOption(value);
                                        firstVariant = value;
                                        btnActive.topPosition3 = $(this).attr('data-option3');
                                        addTooltipVariant('css-status__top',value);
                                        setTimeout(function() {
                                            actionRadioInput(value);
                                        },200)
                                }
                            } else {
                                $(btn).closest('ul[data-position="2"]').find('.product-opt__btn').each(function(index,btnPosition2) {
                                    $('.product-single__variants option').each(function(index,value) {
                                        if ($(value).attr('data-option3') != '-' && $(value).attr('selected') === 'selected') {
                                            removeOption(value);
                                        }
                                    });
        
                                    if($(btnPosition2).hasClass('product-opt__btn_active')) {
                                        $(btnPosition2).removeClass('product-opt__btn_active');
                                    }
    
                                    if($(btn).attr('data-option2') === $(btnPosition2).attr('data-option2')) {
                                        if($('.css-status__bottom').not('m-hide-css')) {
                                            hideTooltipVariant('css-status__top');
                                        }
            
                                        if ($('.payment-buttons .add-to-cart').not('m-select-sz') && $(secondVariant).attr('selected') != 'selected' ) {
                                            disableAddToCart();
                                        }
            
                                        $(btnPosition2).closest('.product-opt__select[data-position="1"]').find('ul[data-position="3"] .product-opt__btn').each(function(index,btnPosition3) {
                                            $(btnPosition3).removeAttr('data-option2');
                                            if ($(btnPosition3).hasClass('product-opt__btn_active')) {
                                                $(btnPosition3).removeClass('product-opt__btn_active');
                                                firstVariant = '-';
                                                activateAddToCart();
                                            }
                                        })
                                        if(btnActive.topPosition2 === $(btnPosition2).attr('data-option2')) {
                                            setTimeout(function() {
                                                btnActive.topPosition2 = '-';
                                                btnActive.topPosition3 = '-';
                                                $(btnPosition2).removeClass('product-opt__btn_active');
                                                if($('.css-status__top').not('m-hide-css')) {
                                                    hideTooltipVariant('css-status__top');
                                                }
                                            },200)
                                        } else {
                                            $(btnPosition2).closest('.product-opt__select[data-position="1"]').find('ul[data-position="3"] .product-opt__btn').each(function(index,btnPosition3) {
                                                $(btnPosition3).attr('data-option2', `${$(btnPosition2).attr('data-option2')}`);
                                            })
                                            setTimeout(function() {
                                                btnActive.bottomPosition2 = $(btnPosition2).attr('data-option2');
                                                $(btnPosition2).addClass('product-opt__btn_active');
                                            },200)
                                        }
                                    }
                                })
        
                                if ($(btn).closest('.product-opt__select[data-position="1"]').find('ul[data-position="3"]').hasClass('product-opt_block_none')) {
                                    $(btn).closest('.product-opt__select[data-position="1"]').find('ul[data-position="3"]').removeClass('product-opt_block_none');
                                }

                                $(btn).closest('.product-opt__select[data-position="1"]').find('ul[data-position="3"] .product-opt__btn').each(function(ind,val) {
                                    $(val).attr("disabled",true);
                                    $(val).addClass('product-opt__btn_none');

                                    if ($(value).attr('data-option1') === $(val).attr('data-option1') && $(value).attr('data-option3') === $(val).attr('data-option3') && $(value).attr('data-css') != 'Out of stock') {
                                        setTimeout(function() {
                                            $(val).removeAttr("disabled");
                                            $(val).removeClass('product-opt__btn_none');
                                        },200)
                                    }
                                })
                            }
                        }
                    }

                if ($(value).attr('data-option3') === '-' &&
                    $(value).attr('data-option1') === $(btn).attr('data-option1') && 
                    $(value).attr('data-option2') === $(btn).attr('data-option2')) {

                        if ($(btn).attr('data-option1') === 'Top') {

                            $('.product-single__variants option').each(function(index,value) {
                                if ($(value).attr('data-option3') === '-' && $(value).attr('data-option1') === $(btn).attr('data-option1') && $(value).attr('selected') === 'selected') {
                                    removeOption(value);
                                }
                            })
    
                            $(btn).closest('ul[data-position="2"]').find('.product-opt__btn').each(function(index,btnPosition2) {

                                if($(btnPosition2).hasClass('product-opt__btn_active')) {
                                    $(btnPosition2).removeClass('product-opt__btn_active')
                                }

                                
                                if($(btn).attr('data-option2') === $(btnPosition2).attr('data-option2')){
                                    if(btnActive.topPosition2 === $(btnPosition2).attr('data-option2')){
                                        $(btnPosition2).removeClass('product-opt__btn_active');
                                        btnActive.topPosition2 = '-';
                                        firstVariant = '-';
                                        activateAddToCart();
                                        if($('.css-status__top').not('m-hide-css')) {
                                            $('.css-status__top').addClass('m-hide-css');
                                              $('.css-status__top').find('.product-opt__inventory').removeClass('product-opt__inventory_show');
                                        }
                                    } else {
                                        $(btn).addClass('product-opt__btn_active');
                                        $(btn).attr('data-id',`${$(value).attr('value')}`);
                                        $(btn).attr('data-active', true);
                                        shooseOption(value);
                                        firstVariant = value;
                                        setTimeout(function() {
                                            actionRadioInput(value);
                                        },200)
                                        addTooltipVariant('css-status__top',value);
                                        activateAddToCart();
                                        btnActive.topPosition2 = $(btnPosition2).attr('data-option2');
                                    }
                                }
                            });
                        }

                        if ($(btn).attr('data-option1') === 'Bottom') {

                            $('.product-single__variants option').each(function(index,value) {
                                if ($(value).attr('data-option3') === '-' && $(value).attr('data-option1') === $(btn).attr('data-option1') && $(value).attr('selected') === 'selected') {
                                    removeOption(value);
                                }
                            })
    
                            $(btn).closest('ul[data-position="2"]').find('.product-opt__btn').each(function(index,btnPosition2) {
    
                                if($(btnPosition2).hasClass('product-opt__btn_active')) {
                                    $(btnPosition2).removeClass('product-opt__btn_active')
                                }
                                
                                if($(btn).attr('data-option2') === $(btnPosition2).attr('data-option2')) {
                                    if(btnActive.bottomPosition2 === $(btnPosition2).attr('data-option2')){
                                        $(btnPosition2).removeClass('product-opt__btn_active');
                                        btnActive.bottomPosition2 = '-';
                                        secondVariant = '-';
                                        activateAddToCart();
                                        if($('.css-status__bottom').not('m-hide-css')) {
                                            $('.css-status__bottom').addClass('m-hide-css');
                                              $('.css-status__bottom').find('.product-opt__inventory').removeClass('product-opt__inventory_show');
                                        }
                                    } else {
                                        $(btn).addClass('product-opt__btn_active')
                                        $(btn).attr('data-id',`${$(value).attr('value')}`);
                                        shooseOption(value);
                                        secondVariant = value;
                                        setTimeout(function() {
                                            actionRadioInput(value);
                                        },200)
                                        addTooltipVariant('css-status__bottom',value);
                                        activateAddToCart();
                                        btnActive.bottomPosition2 = $(btnPosition2).attr('data-option2');
                                    }
                                }
                            });
                        }
                }
            });

            // --- Std (non-set) product: size toggle handler ---
            if (!$('.product-option-set').hasClass('js-group') &&
                $(btn).attr('data-option1') !== 'Top' &&
                $(btn).attr('data-option1') !== 'Bottom') {

                var $stdBtn = $(btn);
                var $btnList = $stdBtn.closest('ul[data-position="2"]');
                var stdWasActive = $stdBtn.hasClass('product-opt__btn_active');

                // Deactivate all sibling size buttons first
                $btnList.find('.product-opt__btn').removeClass('product-opt__btn_active').attr('aria-pressed', 'false');

                if (stdWasActive) {
                    // DESELECT
                    firstVariant = '-';
                    $('.product-single__variants option').each(function(i, opt) {
                        if ($(opt).attr('data-option1') === $stdBtn.attr('data-option1') &&
                            $(opt).attr('data-option2') === $stdBtn.attr('data-option2')) {
                            removeOption(opt);
                        }
                    });
                    hideTooltipVariant('css-status__top');
                    $('.js-choose-option').css({display: 'inline'});
                    $('.payment-buttons .add-to-cart').addClass('m-select-sz');
                } else {
                    // SELECT
                    $('.product-single__variants option').each(function(i, opt) {
                        var o1 = $stdBtn.attr('data-option1');
                        var o2 = $stdBtn.attr('data-option2');
                        if ((!o1 || $(opt).attr('data-option1') === o1) &&
                            (!o2 || $(opt).attr('data-option2') === o2)) {
                            $stdBtn.addClass('product-opt__btn_active').attr('aria-pressed', 'true');
                            $stdBtn.attr('data-id', $(opt).attr('value'));
                            clearSelect();
                            shooseOption(opt);
                            firstVariant = opt;
                            setTimeout(function() { actionRadioInput(opt); }, 200);
                            addTooltipVariant('css-status__top', opt);
                            // Enable ADD TO BAG — show original template text, no "ADD TOP" copy
                            $('.js-original-button-text-top').css({display: 'none'});
                            $('.js-original-button-text-bottom').css({display: 'none'});
                            $('.js-original-button-text-both').css({display: 'none'});
                            $('.js-choose-option').css({display: 'none'});
                            $('.payment-buttons .add-to-cart').removeClass('m-select-sz disabled').removeAttr('disabled');
                        }
                    });
                }

                // Clear any lingering size error
                $('.m-size-error').text('').attr('aria-hidden', 'true');
                $('.product-option-set').removeClass('m-size-shake');
            }

            if ($('.product-option-set').hasClass('js-group')) {
                if ($('.product-opt__btn[data-option1="Top"]').hasClass('product-opt__btn_active') && !$('.product-opt__btn[data-option1="Bottom"]').hasClass('product-opt__btn_active')) {
                    $('.js-original-button-text-top').text('SOLD AS SET: Please Select Bottom')
                }
                if (!$('.product-opt__btn[data-option1="Top"]').hasClass('product-opt__btn_active') && $('.product-opt__btn[data-option1="Bottom"]').hasClass('product-opt__btn_active')) {
                    $('.js-original-button-text-bottom').text('SOLD AS SET: Please Select Top')
                }
                $('.product-single__form .btn.add-to-cart').addClass('m-select-sz')
                setTimeout(function() {
                    if ($('.product-opt__btn[data-option1="Top"]').hasClass('product-opt__btn_active') && $('.product-opt__btn[data-option1="Bottom"]').hasClass('product-opt__btn_active')) {
                        $('.product-single__form .btn.add-to-cart').removeClass('m-select-sz')
                    } else {
                        $('.product-single__form .btn.add-to-cart').addClass('m-select-sz')
                    }
                },200)
            }
            
        });


        if ($('.product-option-set').hasClass('js-group')) {
            setTimeout(function() {
                if ($('.product-opt__btn[data-option1="Top"]').hasClass('product-opt__btn_active') && $('.product-opt__btn[data-option1="Bottom"]').hasClass('product-opt__btn_active')) {
                    $('.product-single__form .btn.add-to-cart').removeClass('m-select-sz')
                } else {
                    $('.product-single__form .btn.add-to-cart').addClass('m-select-sz')
                }
            },1500)

            setTimeout(function() {
                if (!$('.product-opt__btn[data-option1="Top"]').hasClass('product-opt__btn_active') && $('.product-opt__btn[data-option1="Bottom"]').hasClass('product-opt__btn_active')) {
                    disableAddToCart()
                }
            },2000)

            let url = window.location.href;
            let value = window.location.href.substring(window.location.href.lastIndexOf('?') + 1);
            if (window.location.href.indexOf("variant") > -1) {
                let newUrl = url.replace(value,' ').replace('?',' ');
                window.location.href = newUrl;
            }
            
        }

        $(document).on('click', '.js-qty__adjust.js-qty__adjust--minus', function(e) {
            let qty = $(this).closest('.js-qty__wrapper').find('.js-qty__num').val(),
                commonId = $(this).closest('.ajaxcart__product').find('.js-group-prp').data('ks');
            if (qty == 0) {
                setTimeout(function() {
                    $('.js-group-prp[data-ks="'+ commonId +'"]').closest('.ajaxcart__product').find('.js-qty__num').val(0).trigger('change');
                    $('.js-group-prp[data-ks="'+ commonId +'"]').closest('.ajaxcart__product').find('.js-qty__adjust--minus').trigger('click');
                },1000)
            }
        });

        $(document).on('click', '.product-opt__wrapper', function(e) {
            e.preventDefault();
            $('.payment-buttons .add-to-cart').addClass('btn--loading');
            if ($(firstVariant).attr('selected') === 'selected' && $(secondVariant).attr('selected') === 'selected') {
                clearSelect();
                $('.product-single__variants option').each(function(index,value) { 
                    if ($(firstVariant).attr('value') === $(value).attr('value')) {
                        clearSelect();
                        shooseOption(value);
                        actionRadioInput(value);
                        updateDrawerFromOption(value);
                        setTimeout(function() {
                            var firstAdd = theme.cart.addItemFromForm($('.product-single__form').serialize());
                            removeOption(value);
                            firstVariant = '-';
                            // Add the second piece only after the first add finishes: overlapping cart/add requests can drop one (slow mobile connections)
                            $.when(firstAdd).always(function() {
                            $('.product-single__variants option').each(function(index,value) {
                                if ($(secondVariant).attr('value') === $(value).attr('value')) {
                                    shooseOption(value);
                                }
                            });

                            $('.product-single__variants option').each(function(index,value) {
                                if ($(secondVariant).attr('value') === $(value).attr('value')) {
                                    clearSelect();
                                    shooseOption(value);
                                    actionRadioInput(value);
                                    updateDrawerFromOption(value);
                                    setTimeout(function() {
                                        $('.payment-buttons .add-to-cart').trigger('click');
                                        removeOption(value);
                                        secondVariant = '-';
                                        clearBtnSize();
                                        disableAddToCart();
                                        hideTooltipVariant('css-status__bottom');
                                        hideTooltipVariant('css-status__top');
                                        resetButtonValues();
                                    },500)
                                }  
                            })
                            });

                        },500)
                    }
                })

            } else {
                $('.payment-buttons .add-to-cart').removeClass('btn--loading');
                // Sold As Set (js-group): BOTH top and bottom are mandatory — block any single-piece purchase.
                if ($('.product-option-set').hasClass('js-group')) {
                    if (!$('.m-size-error').length) { $('.product-option-set').after('<span class="m-size-error" role="alert" aria-live="assertive" aria-hidden="true"></span>'); }
                    var $sasErr = $('.m-size-error');
                    var sasMsg = 'This item is Sold As Set — please select both a top and bottom size.';
                    if (firstVariant !== '-' && secondVariant === '-') {
                        sasMsg = 'Sold As Set: please also select a bottom size.';
                        $('ul[data-position="2"]').filter(function() { return $(this).find('.product-opt__btn[data-option1="Bottom"]').length > 0; }).addClass('m-size-shake');
                        setTimeout(function() { $('ul[data-position="2"]').removeClass('m-size-shake'); }, 600);
                    } else if (firstVariant === '-' && secondVariant !== '-') {
                        sasMsg = 'Sold As Set: please also select a top size.';
                        $('ul[data-position="1"]').filter(function() { return $(this).find('.product-opt__btn[data-option1="Top"]').length > 0; }).addClass('m-size-shake');
                        setTimeout(function() { $('ul[data-position="1"]').removeClass('m-size-shake'); }, 600);
                    } else {
                        $('.product-option-set').addClass('m-size-shake');
                        setTimeout(function() { $('.product-option-set').removeClass('m-size-shake'); }, 600);
                    }
                    $sasErr.text(sasMsg).removeAttr('aria-hidden');
                    setTimeout(function() { $sasErr.text('').attr('aria-hidden', 'true'); }, 3000);
                    return;
                }
                // Grouped-fits: guide user through incomplete bottom selection.
                // A bottom size without a fit must block the add even when a top is selected,
                // otherwise the top is added alone and the chosen bottom is silently dropped.
                if ($('body').hasClass('prod-type-grouped-fits')) {
                    var $bottomSizeActive = $('.product-opt__btn[data-option1="Bottom"]:not([data-option3])').filter('.product-opt__btn_active');
                    var $fitUlVisible = $('ul[data-position="3"]').not('.product-opt_block_none').filter(function() { return $(this).find('.product-opt__btn[data-option1="Bottom"]').length > 0; });
                    var $bottomFitActive = $('.product-opt__btn[data-option1="Bottom"][data-option3]').filter('.product-opt__btn_active');
                    if (!$('.m-size-error').length) { $('.product-option-set').after('<span class="m-size-error" role="alert" aria-live="assertive" aria-hidden="true"></span>'); }
                    var $gfErr = $('.m-size-error');
                    if (firstVariant === '-' && !$bottomSizeActive.length) {
                        // Nothing selected at all — Top OR Bottom is enough to proceed
                        $('.product-option-set').addClass('m-size-shake');
                        setTimeout(function() { $('.product-option-set').removeClass('m-size-shake'); }, 600);
                        $gfErr.text('Please select a top or bottom size to add to your bag.').removeAttr('aria-hidden');
                        setTimeout(function() { $gfErr.text('').attr('aria-hidden', 'true'); }, 3000);
                        return;
                    }
                    if ($bottomSizeActive.length && $fitUlVisible.length && !$bottomFitActive.length) {
                        $fitUlVisible.addClass('m-size-shake');
                        setTimeout(function() { $fitUlVisible.removeClass('m-size-shake'); }, 600);
                        $gfErr.text('Please select a fit to continue.').removeAttr('aria-hidden');
                        setTimeout(function() { $gfErr.text('').attr('aria-hidden', 'true'); }, 3000);
                        return;
                    }
                }
                // Std product with no size selected — shake and announce error, don't submit
                if ($('body').hasClass('m-std-product') && firstVariant === '-') {
                    $('.product-option-set').addClass('m-size-shake');
                    setTimeout(function() { $('.product-option-set').removeClass('m-size-shake'); }, 600);
                    var $errEl = $('.m-size-error');
                    $errEl.text('Please select a size to continue.').removeAttr('aria-hidden');
                    setTimeout(function() { $errEl.text('').attr('aria-hidden', 'true'); }, 3000);
                    return;
                }
                // Grouped: nothing selected at all — shake and announce error, don't submit
                if ($('body').hasClass('prod-type-grouped') && firstVariant === '-' && secondVariant === '-') {
                    if (!$('.m-size-error').length) { $('.product-option-set').after('<span class="m-size-error" role="alert" aria-live="assertive" aria-hidden="true"></span>'); }
                    $('.product-option-set').addClass('m-size-shake');
                    setTimeout(function() { $('.product-option-set').removeClass('m-size-shake'); }, 600);
                    var $grpErr = $('.m-size-error');
                    $grpErr.text('Please select a top or bottom size to add to your bag.').removeAttr('aria-hidden');
                    setTimeout(function() { $grpErr.text('').attr('aria-hidden', 'true'); }, 3000);
                    return;
                }
                $('.payment-buttons .add-to-cart').trigger('click');
                clearBtnSize();
                disableAddToCart();
                resetButtonValues();
                firstVariant = '-';
                secondVariant = '-';
                hideTooltipVariant('css-status__bottom');
                hideTooltipVariant('css-status__top');
            }
        });

        $(document).on('click', '.swym-button-bar__wrapper', function(e) {
            e.preventDefault();
            if ($(firstVariant).attr('selected') === 'selected' && $(secondVariant).attr('selected') === 'selected') {
                clearSelect();
                $('.product-single__variants option').each(function(index,value) {
                    if ($(firstVariant).attr('value') === $(value).attr('value')) {
                        clearSelect();
                        shooseOption(value);
                        actionRadioInput(value);
                        updateDrawerFromOption(value);
                        setTimeout(function() {
                            $('.swym-button').trigger('click');
                            removeOption(value);
                            firstVariant = '-';
                            setTimeout(function() {
                                $('.product-single__variants option').each(function(index,val) {
                                    if ($(secondVariant).attr('value') === $(val).attr('value')) {
                                        clearSelect();
                                        shooseOption(val);
                                        secondVariant = '-';
                                        actionRadioInput(val);
                                        updateDrawerFromOption(val);
                                        setTimeout(function() {
                                            $('.swym-button').trigger('click');
                                            removeOption(val);
                                            clearBtnSize();
                                            hideTooltipVariant('css-status__bottom');
                                            hideTooltipVariant('css-status__top');
                                            resetButtonValues();
                                        },2000)
                                    }
                                })
                            },2000)
                        },2000)
                    }
                })

            } else {
                $('.product-single__variants option').each(function(index,value) {
                    if ($(firstVariant).attr('selected') === 'selected' && $(firstVariant).attr('value') === $(value).attr('value') || $(secondVariant).attr('selected') === 'selected' && $(secondVariant).attr('value') === $(value).attr('value')) {
                        clearSelect();
                        shooseOption(value);
                        actionRadioInput(value);
                        setTimeout(function(){
                            $('.swym-button').trigger('click');
                            removeOption(value);
                            clearBtnSize();
                            resetButtonValues();
                        },2000)
                        secondVariant = '-';
                        firstVariant = '-';
                        resetButtonValues();
                        hideTooltipVariant('css-status__bottom');
                        hideTooltipVariant('css-status__top');
                    }
                })
            }
        });

        if($('body').hasClass('template-collection') || $('body').hasClass('template-search')) {
            // Mobile QV "What does this mean?" — delegated click handler that opens/closes
            // the tooltip popup correctly.  The generic tooltip() in custom_script_o.js does
            // $(value).next().next() which lands on the hidden <select>, not the .tooltip__block.
            // This handler is mobile-only (≤768px) and targets the body panel's QV tooltip.
            $(document).on('click', '.custom-mobile-qv-p .qv-tooltip-wrap .js-tooltip.tooltip__button_clickable', function(e) {
                if ($(window).width() <= 768) {
                    e.stopPropagation();
                    var $block = $(this).find('.tooltip__block');
                    if ($block.hasClass('tooltip__block_open')) {
                        $block.removeClass('tooltip__block_open');
                        $('.tooltip__background').remove();
                        $('html, body').css({ overflow: 'auto' });
                    } else {
                        $block.addClass('tooltip__block_open');
                        $(this).parent().append('<div class="tooltip__background"></div>');
                        $('html, body').css({ overflow: 'hidden' });
                    }
                }
            });
            // Close mobile tooltip when close button or background tapped
            $(document).on('click', '.custom-mobile-qv-p .js-tooltip-btn-close, .custom-mobile-qv-p .js-tooltip__cross-close', function(e) {
                if ($(window).width() <= 768) {
                    e.stopPropagation();
                    $(this).closest('.tooltip__block').removeClass('tooltip__block_open');
                    $('.tooltip__background').remove();
                    $('html, body').css({ overflow: 'auto' });
                }
            });

            $(document).mouseup(function (e) {
                // Nothing to close unless a quick view is open — skip the full QV reset on every tap (INP)
                if (!document.querySelector('.js-prod-item.m-selected, body.qv-loaded')) return;
                if ($(e.target).closest(".m-content-part, .tooltip__block, .js-tooltip, .qv-tooltip-wrap").length
                === 0 && !$('.size-popup').is(':visible')) {
                    $('.qv-product-title').trigger('click')
                }
            });
        }

        function quickView(handle, productId) {
            if ($('#quick-view').length == 0){$("body").append('<div id="quick-view"></div>');}
            var product_handle = handle;
            $('#quick-view').removeClass();
            $('#quick-view').addClass(product_handle);
            jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
                var qvCurrency = $('meta[name="locale-bar--current-currency"]').attr('content') || 'USD';
                var qvIntlDdu = (product.tags && product.tags.indexOf('::INTL-to-USA-DDU') > -1) ? 'true' : '';
                $('.qv-add-to-cart .js-form-intl-ddu').remove();
                $('.qv-add-to-cart').prepend('<span class="js-form-intl-ddu" data-currency="'+ qvCurrency +'" data-intl-ddu="'+ qvIntlDdu +'" aria-hidden="true"></span>');

                if (product.tags.indexOf("::SOLD AS SET") > -1) {
                   $('.js-ul-qv').addClass('product-option-set js-group');
                    let setOnly = $(`
                        <span class="tooltip">
                            <div class="js-tooltip tooltip__button tooltip__button_clickable sold-as-set">Sold As Set Only
                                <div class="tooltip__block">
                                    <div class="tooltip__indent"></div>
                                    <div class="tooltip__wrapper">
                                        <div class="js-tooltip__cross-close tooltip__close__wrapper">
                                            <div class="tooltip__close"></div>
                                        </div>
                                        <div class="tooltip__content tooltip__content_sold-as-set">
                                            <p>This item must be purchased or returned as a Set — i.e. both TOP and BOTTOM together.</p>
                                            <!-- <p class="tooltip__content__info"></p> -->
                                            <p></p>
                                        </div>
                                        <div class="js-tooltip-btn-close tooltip__btn-close">
                                            <span>Close</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <select class="tooltip__variants"></select>
                        </span>
                    `)
                   $(setOnly).insertBefore(".js-ul-qv");
                }

              if (product.tags.indexOf("runs-small") > -1) {
                $('.product-tips').remove();
                let runsSmall = $(`
                     <div class="product-tips">
                        <span>Sizing Tip</span> Runs small. We recommend sizing up
                      </div>
                `);
                $(runsSmall).insertBefore(".js-ul-qv");
              }
              
              if (product.tags.indexOf("made-to-order") > -1) {
                  $('.product-tips').remove();
                  let madetoOrder = $(`
                       <div class="product-tips">
                          <span>Made-to-Order</span><br />Can take up to 5 business days before shipping
                        </div>
                  `);
                  $(madetoOrder).insertBefore(".js-ul-qv");
                }

                var options = product.options;
                let tmpVendor = product.vendor.replace("&", "").replace("  ", "-").replace(/\s+/g, "-");

                $('.custom-mobile-qv-p').addClass(tmpVendor.toLowerCase());
                $('.qv-product-size').attr('data-vendor', tmpVendor.toLowerCase())

                $('.m-prod-details').attr('href', product.url)

                if (!$('.qv-add-button .js-original-button-text-top').length) {
                    $('.qv-add-button').append('<span class="js-original-button-text-top" style="display:none">add top to bag</span>');
                }
                if (!$('.qv-add-button .js-original-button-text-bottom').length) {
                    $('.qv-add-button').append('<span class="js-original-button-text-bottom" style="display:none">add bottom to bag</span>');
                }
                if (!$('.qv-add-button .js-original-button-text-both').length) {
                    $('.qv-add-button').append('<span class="js-original-button-text-both" style="display:none">add both to bag</span>');
                }

                if (options[1] != undefined) {
                    if (options[0].name == 'Size' && options[1].name == 'Fit') {
                        $('.qv-product-options').addClass('m-cst-hide-cs')
                    } else {
                        $('.qv-product-options').removeClass('m-cst-hide-cs')
                    }
                } else {
                    $('.qv-product-options').addClass('m-cst-hide-cs')
                    setTimeout(function() {
                        if (options[0].name == 'Size' && $('.js-prod-item .js-ul-qv > li').length == 1) {
                            $('.qv-product-options').removeClass('m-cst-hide-cs')
                        }
                        if ($(window).width() < 768 && options[0].name == 'Size' && $('.custom-mobile-qv-p .js-ul-qv > li').length == 1) {
                            $('.qv-product-options').removeClass('m-cst-hide-cs')
                        }
                    }, 600);
                }
                // Build a set of all option1||option2 combos that actually exist
                // (regardless of availability) so we can skip rendering size
                // buttons for combinations that have no variant at all (e.g. D
                // under Bottom when D is a Top-only size).
                var existingCombos = new Set();
                if (product.variants) {
                    product.variants.forEach(function(v) {
                        if (v.option1 && v.option2) {
                            existingCombos.add(v.option1 + '||' + v.option2);
                        }
                    });
                }

                $(options).each(function (i, option) {
                    if(option.position == 1 && option.name == 'Select'){
                        $(option.values).each(function (i, value) {
                            $('.js-ul-qv').append(`
                                <li class="product-opt__select product-opt_block_${option.position}" 
                                data-name="${option.name}"
                                data-position="${option.position}"
                                value="${value}"
                                >
                                    <div class='product-opt__select-name'><span class='qv-opt-label'>${value}:</span> <span class='product-opt__select-price product-opt__select-price_none'></span></div>
                                    <input type="radio"
                                    required=""
                                    value="${value}"
                                    data-index="option1"
                                    name="${option.name}"
                                    class="product-opt__input">
                                </li>`
                            );

                            $(options).each(function (i, value1) {
                                if(value1.position == 2){
                                    if (!$('.js-ul-qv .product-opt__select.product-opt_block_'+ option.position +'[value="'+ value +'"] ul').length) {
                                        $('.js-ul-qv .product-opt__select.product-opt_block_'+ option.position +'[value="'+ value +'"]').append(`
                                            <ul class='product-opt_block_${value1.position}' data-name="${value1.name}" data-position="${value1.position}">
                                                <span class='product-opt__name product-opt__name-${value1.name.toLowerCase().replace(/\s+/g, "-")}'>${value1.name}</span>
                                            </ul>
                                            <span class="css-status"><span class="css-status-msg"></span><span class="ships_from_country"></span></span>
                                        `);
                                    }

                              const desiredOrder = [
                                'XXS', 'XS', 'XS/S', 'S', 'S/M', 'M', 'M/L', 'L', 'L/XL', 'XL', 'XL/XXL', 'XXL'
                              ];
                              
                              $(value1.values)
                                .sort((a, b) => {
                                  const indexA = desiredOrder.indexOf(a);
                                  const indexB = desiredOrder.indexOf(b);
                                  // Items not in desiredOrder go to the end
                                  return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
                                })
                                .each(function (i, value2) {
                                  // Skip if no variant exists for this piece+size combo
                                  if (!existingCombos.has(value + '||' + value2)) return;
                                  $('.js-ul-qv .product-opt__select.product-opt_block_' + option.position + '[value="' + value + '"] ul')
                                    .append(`
                                      <li class='product-opt__size'>
                                        <button class='product-opt__btn product-opt__btn_none' data-option1="${value}" data-option2="${value2}" disabled>${value2}</button>
                                        <input type="radio"
                                        required=""
                                        value="${value2}"
                                        data-index="option2"
                                        name="${option.name}"
                                        class="product-opt__input">
                                      </li>
                                    `);
                                });

                                }
                                if(value1.position == 3){
                                    if (!$('.js-ul-qv .product-opt__select.product-opt_block_'+ option.position +'[value="'+ value +'"] [value="Bottom"] ul').length) {
                                        $('.js-ul-qv .product-opt__select.product-opt_block_'+ option.position +'[value="Bottom"]').append(`
                                            <ul class='product-opt_block_${value1.position} product-opt_block_none' data-name="${value1.name}" data-position="${value1.position}">
                                                <span class='product-opt__name product-opt__name-${value1.name.toLowerCase().replace(/\s+/g, "-")}'>${value1.name}</span>
                                            </ul>
                                            <span class="css-status"><span class="css-status-msg"></span><span class="ships_from_country"></span></span>
                                        `);
                                    }

                                    $(value1.values).each(function (i, value3) {
                                        $('.js-ul-qv .product-opt__select.product-opt_block_'+ option.position +'[value="'+ value +'"] ul[data-name="'+ value1.name +'"]').append(`
                                            <li class='product-opt__size'>
                                                <button class='product-opt__btn product-opt__btn_none' data-option1="${value}" data-option2="${value3}" data-option3="${value3}" disabled>${value3}</button>
                                                <input type="radio"
                                                required=""
                                                value="${value3}"
                                                data-index="option2"
                                                name="${option.name}"
                                                class="product-opt__input sd">
                                            </li>
                                        `)
                                    });
                                }

                            });
                        
                        });
                    } 
                 
                    if(option.position == 1 && option.name != 'Select'){
                        $('.js-ul-qv').append(`
                            <li class="product-opt__select product-opt_block_${option.position}" 
                            data-name="${option.name}"
                            data-position="${option.position}"
                            value="${option.name}"
                            >
                                <div class='product-opt__select-name'><span class='product-opt__select-price product-opt__select-price_none'></span></div>
                                <input type="radio"
                                required=""
                                value="${option.name}"
                                data-index="option1"
                                name="${option.name}"
                                class="product-opt__input">
                            </li>`
                        );

                        let ops = option.values;

                        $(options).each(function (i, value1) {
                            if (!$('.js-ul-qv .product-opt__select.product-opt_block_'+ option.position +'[value="'+ option.name +'"] ul').length) {
                                $('.js-ul-qv .product-opt__select.product-opt_block_'+ option.position +'[value="'+ option.name +'"]').append(`
                                    <ul class='product-opt_block_${value1.position}' data-name="${value1.name}" data-position="${value1.position}">
                                        <span class='product-opt__name product-opt__name-${value1.name.toLowerCase().replace(/\s+/g, "-")}'>${value1.name}</span>
                                    </ul>
                                    <span class="css-status"><span class="css-status-msg"></span><span class="ships_from_country"></span></span>
                                `);
                            }
                        });

                        $(ops).each(function (i, value2) {
                            $('.js-ul-qv .product-opt__select.product-opt_block_'+ option.position +'[value="'+ option.name +'"] ul').append(`
                                <li class='product-opt__size'>
                                    <button class='product-opt__btn product-opt__btn_none' data-option1="${option.name}" data-option2="${value2}" disabled>${value2}</button>
                                    <input type="radio"
                                    required=""
                                    value="${value2}"
                                    data-index="option2"
                                    name="${option.name}"
                                    class="product-opt__input">
                                </li>
                            `)
                        });
                        
                        if (options[1] != undefined) {
                            if (options[0].name == 'Size' && options[1].name == 'Fit') {

                                if (!$('.js-ul-qv .product-opt__select.product-opt_block_1[value="Size"] ul[data-name="Fit"]').length) {
                                    $('.js-ul-qv .product-opt__select.product-opt_block_1[value="Size"]').append(`
                                        <ul class='product-opt_block_3 product-opt_block_none' data-name="Fit" data-position="3">
                                            <span class='product-opt__name product-opt__name-${options[1].name.toLowerCase().replace(/\s+/g, "-")}'>${options[1].name}</span>
                                        </ul>
                                        <span class="css-status"><span class="css-status-msg"></span><span class="ships_from_country"></span></span>
                                    `);
                                }
    
                                $(options).each(function (i, value1) {
                                    if (value1.name == 'Fit') {
                                        $(value1.values).each(function (i, value3) {
                                            $('.js-ul-qv .product-opt__select.product-opt_block_1[value="Size"] ul[data-name="Fit"]').append(`
                                                <li class='product-opt__size'>
                                                    <button class='product-opt__btn product-opt__btn_none' data-option1="${option.name}" data-option4="${value1.name}" data-option2="${value3}" data-option3="${value3}" disabled>${value3}</button>
                                                    <input type="radio"
                                                    required=""
                                                    value="${value3}"
                                                    data-index="option2"
                                                    name="${option.name}"
                                                    class="product-opt__input sd">
                                                </li>
                                            `)
                                        });
                                    }
                                });
                            }
                        }
                    }
            
                });

            }).done(function() {
                quickViewVariantsCheker(productId);
                setTimeout(function() {
                    $($('.css-status')[0]).addClass('css-status__top').addClass('m-hide-css');
                    if ($('.product-opt__select[value="Bottom"] > ul').hasClass('product-opt_block_3')) {
                        $('.product-opt__select[value="Bottom"] > .css-status:not(:last-child)').remove()
                        $('.product-opt__select[value="Bottom"] > .css-status:last-child').addClass('css-status__bottom').addClass('m-hide-css')
                    } else {
                        $($('.css-status')[1]).addClass('css-status__bottom').addClass('m-hide-css');
                    }
                    $('body').addClass('qv-loaded')
                },500);
            });
        };

        function quickViewVariantsCheker(prodId) {
            $('.js-prod-item[data-id="'+ prodId +'"] .js-original-select-wrap-prod option').each(function(index,value) {
                if ($('.custom-mobile-qv-p .product-opt__select[data-name="Select"]').length) {

                    $('.custom-mobile-qv-p[data-prod-id="'+ prodId +'"] .product-opt__select[data-name="Select"]').each(function(ind,select) {
                        $(select).find('ul[data-position="2"] .product-opt__btn').each(function(ind,val) {
                            if ($(value).attr('data-option1') === $(val).attr('data-option1') && 
                                $(value).attr('data-option2') === $(val).attr('data-option2') &&
                                $(value).attr('data-css') != 'Out of stock') {
                                    $(val).removeClass('product-opt__btn_none');
                                    $(val).removeAttr("disabled");
                                    if ($(select).find('.product-opt__select-price').hasClass('product-opt__select-price_none')) {
                                        let fullPriceChk = $(value).attr('data-compare_at_price');
                                        let fullPrice = parseFloat($(value).attr('data-compare_at_price'));
                                        let currentPrice = parseFloat($(value).attr('data-price'));
                                        $(select).find('.product-opt__select-price').removeClass('product-opt__select-price_none');
                                        if(fullPriceChk != 'null' && !Number.isNaN(fullPrice) && fullPriceChk != undefined) {
                                            $('<span class="qv-money">'+ Utils.formatMoney(fullPrice) +'</span>').appendTo(`.product-opt__select[value="${$(value).attr('data-option1')}"] .product-opt__select-price`).addClass('product-opt__full-price');
                                            $('<span class="qv-money">'+ Utils.formatMoney(currentPrice) +'</span>').appendTo(`.product-opt__select[value="${$(value).attr('data-option1')}"] .product-opt__select-price`).addClass('product-opt__current-price');
                                        } else {
                                            $('<span class="qv-money">'+ Utils.formatMoney(currentPrice) +'</span>').appendTo(`.product-opt__select[value="${$(value).attr('data-option1')}"] .product-opt__select-price`);
                                        }
                                    }
                            }
                        })
                    })
                }
                if ($('.custom-mobile-qv-p .product-opt__select[data-name="Size"]').length) {
                    $('.custom-mobile-qv-p[data-prod-id="'+ prodId +'"] .product-opt__select[data-name="Size"]').each(function(ind,select) {
                        $(select).find('ul[data-position="1"] .product-opt__btn').each(function(ind,val) {
                            if ($(value).attr('data-option1') === $(val).attr('data-option2') && 
                                $(value).attr('data-css') != 'Out of stock') {
                                    $(val).removeClass('product-opt__btn_none');
                                    $(val).removeAttr("disabled");
                                    if ($(select).find('.product-opt__select-price').hasClass('product-opt__select-price_none')) {
                                        let fullPriceChk = $(value).attr('data-compare_at_price');
                                        let fullPrice = parseFloat($(value).attr('data-compare_at_price'));
                                        let currentPrice = parseFloat($(value).attr('data-price'));
                                        $(select).find('.product-opt__select-price').removeClass('product-opt__select-price_none');
                                        if(fullPriceChk != 'null' && !Number.isNaN(fullPrice) && fullPriceChk != undefined) {
                                            $('<span class="qv-money">'+ Utils.formatMoney(fullPrice) +'</span>').appendTo(`.product-opt__select[value="Size"] .product-opt__select-price`).addClass('product-opt__full-price');
                                            $('<span class="qv-money">'+ Utils.formatMoney(currentPrice) +'</span>').appendTo(`.product-opt__select[value="Size"] .product-opt__select-price`).addClass('product-opt__current-price');
                                        } else {
                                            $('<span class="qv-money">'+ Utils.formatMoney(currentPrice) +'</span>').appendTo(`.product-opt__select[value="Size"] .product-opt__select-price`);
                                        }
                                    }
                            }
                        })
                    })
                }
            });
        }

        var variantOneId = '', 
        variantTwoId = '';

        $(document).on('click', '.js-ul-qv .product-opt__btn', function(e) {
            variantOneId = '',
            variantTwoId = '';
            e.preventDefault();
            let prodId = $(this).closest('.custom-mobile-qv-p').attr('data-prod-id');
            let btn = this;


            var flag = true;

            if ($(btn).attr('data-option1') === 'Size') {
                if($(btn).hasClass('product-opt__btn_active')) {
                    $('.product-opt__btn').removeClass('product-opt__btn_active')
                    $(btn).removeClass('product-opt__btn_active')
                    $('.css-status__top').addClass('m-hide-css');
                    $('.qv-add-button').addClass('m-select-sz');
                    flag = false;
                }
            }

            if (flag == true) {
                $('.js-prod-item[data-id="'+ prodId +'"] .js-original-select-wrap-prod option').each(function(index,value) {
                    if ($(value).attr('data-option3') === '' || $(value).attr('data-option3') == 'undefined' || $(value).attr('data-option3') == undefined) {
                        $(value).attr('data-option3', '-')
                    }
                    if ($(value).attr('data-option3') != '-' &&
                        $(value).attr('data-option1') === $(btn).attr('data-option1') && 
                        $(value).attr('data-option2') === $(btn).attr('data-option2')) {
                            if ($(btn).attr('data-option1') === 'Bottom' || $(btn).attr('data-option1') === 'Size') {
                                let attr = $(btn).attr('data-option3');
                                if (typeof attr !== typeof undefined && attr !== false) {
                                    if($(value).attr('data-option1') === $(btn).attr('data-option1') && $(value).attr('data-option2') === $(btn).attr('data-option2') && $(value).attr('data-option3') === $(btn).attr('data-option3')) {
                                        let val = btn;
                                        $('.js-prod-item[data-id="'+ prodId +'"] .js-original-select-wrap-prod option').each(function(index,value) {
                                            if ($(value).attr('data-option3') != '-' && $(value).attr('selected') === 'selected') {
                                                removeOption(value);
                                            }
                                        })
                                        $(val).closest('ul[data-position="3"]').find('.product-opt__btn').each(function(index,btnPosition3) {
                                            if ($(btnPosition3).hasClass('product-opt__btn_active')) {
                                                $(btnPosition3).removeClass('product-opt__btn_active');
                                            }
                                            setTimeout(function() {
                                                activateAddToCart();
                                            },200)
                                        
                                        })
                                            $(val).addClass('product-opt__btn_active');
                                            $(val).attr('data-id',`${$(value).attr('value')}`);
                                            shooseOption(value);
                                            secondVariant = value;
                                            btnActive.bottomPosition3 = $(this).attr('data-option3');
                                            addTooltipVariant('css-status__bottom',value);
                                            setTimeout(function() {
                                                actionRadioInput(value);
                                            },200)
                                    }
                                } else {
                                    $(btn).closest('ul[data-position="2"]').find('.product-opt__btn').each(function(index,btnPosition2) {
                                        $('.js-prod-item[data-id="'+ prodId +'"] .js-original-select-wrap-prod option').each(function(index,value) {
                                            if ($(value).attr('data-option3') != '-' && $(value).attr('selected') === 'selected') {
                                                removeOption(value);
                                            }
                                        });
            
                                        if($(btnPosition2).hasClass('product-opt__btn_active')) {
                                            $(btnPosition2).removeClass('product-opt__btn_active');
                                        }
        
                                        if($(btn).attr('data-option2') === $(btnPosition2).attr('data-option2')) {
                                            if($('.css-status__bottom').not('m-hide-css')) {
                                                hideTooltipVariant('css-status__bottom');
                                            }
                
                                            if ($('.payment-buttons .add-to-cart').not('m-select-sz') && $(firstVariant).attr('selected') != 'selected' ) {
                                                disableAddToCart();
                                            }
                
                                            $(btnPosition2).closest('.product-opt__select[data-position="1"]').find('ul[data-position="3"] .product-opt__btn').each(function(index,btnPosition3) {
                                                $(btnPosition3).removeAttr('data-option2');
                                                if ($(btnPosition3).hasClass('product-opt__btn_active')) {
                                                    $(btnPosition3).removeClass('product-opt__btn_active');
                                                    secondVariant = '-';
                                                    activateAddToCart();
                                                }
                                            })
                                            
                                            if(btnActive.bottomPosition2 === $(btnPosition2).attr('data-option2')) {
                                                setTimeout(function() {
                                                    btnActive.bottomPosition2 = '-';
                                                    btnActive.bottomPosition3 = '-';
                                                    $(btnPosition2).removeClass('product-opt__btn_active');
                                                    if($('.css-status__bottom').not('m-hide-css')) {
                                                        hideTooltipVariant('css-status__bottom');
                                                    }
                                                },200)
                                            } else {
                                                $(btnPosition2).closest('.product-opt__select[data-position="1"]').find('ul[data-position="3"] .product-opt__btn').each(function(index,btnPosition3) {
                                                    $(btnPosition3).attr('data-option2', `${$(btnPosition2).attr('data-option2')}`);
                                                })
                                                setTimeout(function() {
                                                    btnActive.bottomPosition2 = $(btnPosition2).attr('data-option2');
                                                    $(btnPosition2).addClass('product-opt__btn_active');
                                                },200)
                                            }
                                        }
                                    })
            
                                    if ($(btn).closest('.product-opt__select[data-position="1"]').find('ul[data-position="3"]').hasClass('product-opt_block_none')) {
                                        $(btn).closest('.product-opt__select[data-position="1"]').find('ul[data-position="3"]').removeClass('product-opt_block_none');
                                    }
                                    
                                    $(btn).closest('.product-opt__select[data-position="1"]').find('ul[data-position="3"] .product-opt__btn').each(function(ind,val) {
                                        $(val).attr("disabled",true);
                                        $(val).addClass('product-opt__btn_none');

                                        if ($(value).attr('data-option1') === $(val).attr('data-option1') && $(value).attr('data-option3') === $(val).attr('data-option3') && $(value).attr('data-css') != 'Out of stock') {
                                            setTimeout(function() {
                                                $(val).removeAttr("disabled");
                                                $(val).removeClass('product-opt__btn_none');
                                            },200)
                                        }
                                    })
                                }
        
                            }
                            if ($(btn).attr('data-option1') === 'Top') {
                                let attr = $(btn).attr('data-option3');
                                if (typeof attr !== typeof undefined && attr !== false) {
                                    if($(value).attr('data-option1') === $(btn).attr('data-option1') && $(value).attr('data-option2') === $(btn).attr('data-option2') && $(value).attr('data-option3') === $(btn).attr('data-option3')) {
                                        let val = btn;
                                        $('.js-prod-item[data-id="'+ prodId +'"] .js-original-select-wrap-prod option').each(function(index,value) {
                                            if ($(value).attr('data-option3') != '-' && $(value).attr('selected') === 'selected') {
                                                removeOption(value);
                                            }
                                        })
                                        $(val).closest('ul[data-position="3"]').find('.product-opt__btn').each(function(index,btnPosition3) {
                                            if ($(btnPosition3).hasClass('product-opt__btn_active')) {
                                                $(btnPosition3).removeClass('product-opt__btn_active');
                                            }
                                            setTimeout(function() {
                                                activateAddToCart();
                                            },200)
                                        
                                        })
                                            $(val).addClass('product-opt__btn_active');
                                            $(val).attr('data-id',`${$(value).attr('value')}`);
                                            shooseOption(value);
                                            firstVariant = value;
                                            btnActive.topPosition3 = $(this).attr('data-option3');
                                            addTooltipVariant('css-status__top',value);
                                            setTimeout(function() {
                                                actionRadioInput(value);
                                            },200)
                                    }
                                } else {
                                    $(btn).closest('ul[data-position="2"]').find('.product-opt__btn').each(function(index,btnPosition2) {
                                        $('.js-prod-item[data-id="'+ prodId +'"] .js-original-select-wrap-prod option').each(function(index,value) {
                                            if ($(value).attr('data-option3') != '-' && $(value).attr('selected') === 'selected') {
                                                removeOption(value);
                                            }
                                        });
            
                                        if($(btnPosition2).hasClass('product-opt__btn_active')) {
                                            $(btnPosition2).removeClass('product-opt__btn_active');
                                        }
        
                                        if($(btn).attr('data-option2') === $(btnPosition2).attr('data-option2')) {
                                            if($('.css-status__bottom').not('m-hide-css')) {
                                                hideTooltipVariant('css-status__top');
                                            }
                
                                            if ($('.payment-buttons .add-to-cart').not('m-select-sz') && $(secondVariant).attr('selected') != 'selected' ) {
                                                disableAddToCart();
                                            }
                
                                            $(btnPosition2).closest('.product-opt__select[data-position="1"]').find('ul[data-position="3"] .product-opt__btn').each(function(index,btnPosition3) {
                                                $(btnPosition3).removeAttr('data-option2');
                                                if ($(btnPosition3).hasClass('product-opt__btn_active')) {
                                                    $(btnPosition3).removeClass('product-opt__btn_active');
                                                    firstVariant = '-';
                                                    activateAddToCart();
                                                }
                                            })
                                            if(btnActive.topPosition2 === $(btnPosition2).attr('data-option2')) {
                                                setTimeout(function() {
                                                    btnActive.topPosition2 = '-';
                                                    btnActive.topPosition3 = '-';
                                                    $(btnPosition2).removeClass('product-opt__btn_active');
                                                    if($('.css-status__top').not('m-hide-css')) {
                                                        hideTooltipVariant('css-status__top');
                                                    }
                                                },200)
                                            } else {
                                                $(btnPosition2).closest('.product-opt__select[data-position="1"]').find('ul[data-position="3"] .product-opt__btn').each(function(index,btnPosition3) {
                                                    $(btnPosition3).attr('data-option2', `${$(btnPosition2).attr('data-option2')}`);
                                                })
                                                setTimeout(function() {
                                                    btnActive.bottomPosition2 = $(btnPosition2).attr('data-option2');
                                                    $(btnPosition2).addClass('product-opt__btn_active');
                                                },200)
                                            }
                                        }
                                    })
            
                                    if ($(btn).closest('.product-opt__select[data-position="1"]').find('ul[data-position="3"]').hasClass('product-opt_block_none')) {
                                        $(btn).closest('.product-opt__select[data-position="1"]').find('ul[data-position="3"]').removeClass('product-opt_block_none');
                                    }
    
                                    $(btn).closest('.product-opt__select[data-position="1"]').find('ul[data-position="3"] .product-opt__btn').each(function(ind,val) {
                                        $(val).attr("disabled",true);
                                        $(val).addClass('product-opt__btn_none');
    
                                        if ($(value).attr('data-option1') === $(val).attr('data-option1') && $(value).attr('data-option3') === $(val).attr('data-option3') && $(value).attr('data-css') != 'Out of stock') {
                                            setTimeout(function() {
                                                $(val).removeAttr("disabled");
                                                $(val).removeClass('product-opt__btn_none');
                                            },200)
                                        }
                                    })
                                }
                            }
                        }
    
                    if ($(value).attr('data-option3') === '-' &&
                        $(value).attr('data-option1') === $(btn).attr('data-option1') && 
                        $(value).attr('data-option2') === $(btn).attr('data-option2')) {
                            if ($(btn).attr('data-option1') === 'Top') {
    
                                $('.js-prod-item[data-id="'+ prodId +'"] .js-original-select-wrap-prod option').each(function(index,value) {
                                    if ($(value).attr('data-option3') === '-' && $(value).attr('data-option1') === $(btn).attr('data-option1') && $(value).attr('selected') === 'selected') {
                                        removeOption(value);
                                    }
                                })
        
                                $(btn).closest('ul[data-position="2"]').find('.product-opt__btn').each(function(index,btnPosition2) {
    
                                    if($(btnPosition2).hasClass('product-opt__btn_active')) {
                                        $(btnPosition2).removeClass('product-opt__btn_active')
                                    }
    
                                    if($(btn).attr('data-option2') === $(btnPosition2).attr('data-option2')){
                                        if(btnActive.topPosition2 === $(btnPosition2).attr('data-option2')){
                                            $(btnPosition2).removeClass('product-opt__btn_active');
                                            btnActive.topPosition2 = '-';
                                            firstVariant = '-';
                                            activateAddToCart();
                                            if($('.css-status__top').not('m-hide-css')) {
                                                $('.css-status__top').addClass('m-hide-css');
                                                  $('.css-status__top').find('.product-opt__inventory').removeClass('product-opt__inventory_show');
                                            }
                                        } else {
                                            $(btn).addClass('product-opt__btn_active');
                                            $(btn).attr('data-id',`${$(value).attr('value')}`);
                                            $(btn).attr('data-active', true);
                                            shooseOption(value);
                                            firstVariant = value;
                                            setTimeout(function() {
                                                actionRadioInput(value);
                                            },200)
                                            addTooltipVariant('css-status__top',value);
                                            activateAddToCart();
                                            btnActive.topPosition2 = $(btnPosition2).attr('data-option2');
                                        }
                                    }
                                });
                            }
    
                            if ($(btn).attr('data-option1') === 'Bottom') {
    
                                $('.js-prod-item[data-id="'+ prodId +'"] .js-original-select-wrap-prod option').each(function(index,value) {
                                    if ($(value).attr('data-option3') === '-' && $(value).attr('data-option1') === $(btn).attr('data-option1') && $(value).attr('selected') === 'selected') {
                                        removeOption(value);
                                    }
                                })
        
                                $(btn).closest('ul[data-position="2"]').find('.product-opt__btn').each(function(index,btnPosition2) {
        
                                    if($(btnPosition2).hasClass('product-opt__btn_active')) {
                                        $(btnPosition2).removeClass('product-opt__btn_active')
                                    }
                                    
                                    if($(btn).attr('data-option2') === $(btnPosition2).attr('data-option2')) {
                                        if(btnActive.bottomPosition2 === $(btnPosition2).attr('data-option2')){
                                            $(btnPosition2).removeClass('product-opt__btn_active');
                                            btnActive.bottomPosition2 = '-';
                                            secondVariant = '-';
                                            activateAddToCart();
                                            if($('.css-status__bottom').not('m-hide-css')) {
                                                $('.css-status__bottom').addClass('m-hide-css');
                                                $('.css-status__bottom').find('.product-opt__inventory').removeClass('product-opt__inventory_show');
                                            }
                                        } else {
                                            $(btn).addClass('product-opt__btn_active')
                                            $(btn).attr('data-id',`${$(value).attr('value')}`);
                                            shooseOption(value);
                                            secondVariant = value;
                                            setTimeout(function() {
                                                actionRadioInput(value);
                                            },200)
                                            addTooltipVariant('css-status__bottom',value);
                                            activateAddToCart();
                                            btnActive.bottomPosition2 = $(btnPosition2).attr('data-option2');
                                        }
                                    }
                                });
                            }
                    }
                    
                    // Only the option for the clicked size — otherwise every size runs and the last one's status wins
                    if ($(value).attr('data-option1') != 'undefined' && $(value).attr('data-option2') == 'undefined' && $(value).attr('data-option3') == '-' && $(value).attr('data-option1') === $(btn).attr('data-option2')) {
                        if ($(btn).attr('data-option1') === 'Size') {
                            $('.js-prod-item[data-id="'+ prodId +'"] .js-original-select-wrap-prod option').each(function(index,value) {
                                if ($(value).attr('data-option3') === '-' && $(value).attr('data-option1') === $(btn).attr('data-option1') && $(value).attr('selected') === 'selected') {
                                    removeOption(value);
                                }
                            })
    
                            $(btn).closest('ul[data-position="1"]').find('.product-opt__btn').each(function(index,btnPosition2) {
    
                                if($(btnPosition2).hasClass('product-opt__btn_active')) {
                                    $(btnPosition2).removeClass('product-opt__btn_active')
                                }
    
                                if($(btn).attr('data-option2') === $(btnPosition2).attr('data-option2')){
                                    if(btnActive.topPosition2 === $(btnPosition2).attr('data-option1')){
                                        $(btnPosition2).removeClass('product-opt__btn_active');
                                        btnActive.topPosition2 = '-';
                                        firstVariant = '-';
                                        activateAddToCart();
                                        if($('.css-status__top').not('m-hide-css')) {
                                            $('.css-status__top').addClass('m-hide-css');
                                              $('.css-status__top').find('.product-opt__inventory').removeClass('product-opt__inventory_show');
                                        }
                                    } else {
                                        $(btn).addClass('product-opt__btn_active');
                                        $(btn).attr('data-id',`${$(value).attr('value')}`);
                                        $(btn).attr('data-active', true);
                                        shooseOption(value);
                                        firstVariant = value;
                                        setTimeout(function() {
                                            actionRadioInput(value);
                                        },200)
                                        addTooltipVariant('css-status__top',value);
                                        activateAddToCart();
                                        $('.js-original-button-text-top').hide();
                                        $('.js-choose-option').show()
                                        btnActive.topPosition2 = $(btnPosition2).attr('data-option2');
                                    }
                                }

                                $('.js-original-button-text-both').hide()
                            });
                        }
                    }

                    if ($(value).attr('data-option1') != 'undefined' && $(value).attr('data-option2') != 'undefined' && $(value).attr('data-option3') == '-') {
                        if ($(btn).attr('data-option1') === 'Size' && $(btn).attr('data-option4') !== 'Fit') {
                            $('.js-prod-item[data-id="'+ prodId +'"] .js-original-select-wrap-prod option').each(function(index,value) {
                                if ($(value).attr('data-option3') === '-' && $(value).attr('data-option1') === $(btn).attr('data-option1') && $(value).attr('selected') === 'selected') {
                                    removeOption(value);
                                }
                            })

                            $(btn).closest('ul[data-position="1"]').find('.product-opt__btn').each(function(index,btnPosition2) {
                                $('.js-prod-item[data-id="'+ prodId +'"] .js-original-select-wrap-prod option').each(function(index,value) {
                                    if ($(value).attr('data-option3') != '-' && $(value).attr('selected') === 'selected') {
                                        removeOption(value);
                                    }
                                });
    
                                if($(btnPosition2).hasClass('product-opt__btn_active')) {
                                    $(btnPosition2).removeClass('product-opt__btn_active');
                                }

                                if($(btn).attr('data-option2') === $(btnPosition2).attr('data-option2')){
                                    if(btnActive.topPosition2 === $(btnPosition2).attr('data-option1')){
                                        $(btnPosition2).removeClass('product-opt__btn_active');
                                        btnActive.topPosition2 = '-';
                                        firstVariant = '-';
                                        activateAddToCart();
                                        if($('.css-status__top').not('m-hide-css')) {
                                            $('.css-status__top').addClass('m-hide-css');
                                              $('.css-status__top').find('.product-opt__inventory').removeClass('product-opt__inventory_show');
                                        }
                                    } else {
                                        $(btn).addClass('product-opt__btn_active');
                                        $(btn).attr('data-id',`${$(value).attr('value')}`);
                                        $(btn).attr('data-active', true);
                                        shooseOption(value);
                                        firstVariant = value;
                                        setTimeout(function() {
                                            actionRadioInput(value);
                                        },200)
                                        addTooltipVariant('css-status__top',value);
                                        activateAddToCart();
                                        $('.js-original-button-text-top').hide();
                                        $('.js-choose-option').show()
                                        btnActive.topPosition2 = $(btnPosition2).attr('data-option2');
                                    }
                                }

                                $('.js-original-button-text-both').hide()
                             
                                if($(btn).attr('data-option2') === $(btnPosition2).attr('data-option2')) {
                                    if($('.css-status__bottom').not('m-hide-css')) {
                                        hideTooltipVariant('css-status__bottom');
                                    }
        
                                    if ($('.payment-buttons .add-to-cart').not('m-select-sz') && $(firstVariant).attr('selected') != 'selected' ) {
                                        disableAddToCart();
                                    }
        
                                    $(btnPosition2).closest('.product-opt__select[data-position="1"]').find('ul[data-position="3"] .product-opt__btn').each(function(index,btnPosition3) {
                                        $(btnPosition3).removeAttr('data-option2');
                                        if ($(btnPosition3).hasClass('product-opt__btn_active')) {
                                            $(btnPosition3).removeClass('product-opt__btn_active');
                                            secondVariant = '-';
                                            activateAddToCart();
                                        }
                                    })

                                    if(btnActive.bottomPosition2 === $(btnPosition2).attr('data-option2')) {
                                        setTimeout(function() {
                                            btnActive.bottomPosition2 = '-';
                                            btnActive.bottomPosition3 = '-';
                                            $(btnPosition2).removeClass('product-opt__btn_active');
                                            if($('.css-status__bottom').not('m-hide-css')) {
                                                hideTooltipVariant('css-status__bottom');
                                            }
                                            // Hide FIT block when bottom size is deselected (QV)
                                            $(btnPosition2).closest('.product-opt__select[data-position="1"]').find('ul[data-position="3"]').addClass('product-opt_block_none');
                                        },200)
                                    } else {
                                        $(btnPosition2).closest('.product-opt__select[data-position="1"]').find('ul[data-position="3"] .product-opt__btn').each(function(index,btnPosition3) {
                                            $(btnPosition3).attr('data-option2', `${$(btnPosition2).attr('data-option2')}`);
                                        })
                                        setTimeout(function() {
                                            btnActive.bottomPosition2 = $(btnPosition2).attr('data-option2');
                                            $(btnPosition2).addClass('product-opt__btn_active');
                                        },200)
                                    }
                                }
                            })
                            
                            if ($(btn).closest('.product-opt__select[data-position="1"]').find('ul[data-position="3"]').hasClass('product-opt_block_none')) {
                                $(btn).closest('.product-opt__select[data-position="1"]').find('ul[data-position="3"]').removeClass('product-opt_block_none');
                                setTimeout(function() {
                                    $('.qv-add-button').addClass('m-select-sz');
                                },200)
                            }
                            
                            if (!$(btn).closest('.product-opt__select[data-position="1"]').find('ul[data-position="3"]').hasClass('product-opt_block_none')) {
                                setTimeout(function() {
                                    $('.qv-add-button').addClass('m-select-sz');
                                },200)
                            }

                            $('.product-opt_block_1 .css-status__top').hide();

                            $('.css-status__bottom').hide();

                            $(btn).closest('.product-opt__select[data-position="1"]').find('ul[data-position="3"] .product-opt__btn').each(function(ind,val) {
                                $(val).attr("disabled",true);
                                $(val).addClass('product-opt__btn_none');
                                $(value).addClass('valera')
                                $(val).addClass('boris')
                                if ($(value).attr('data-option4') === $(val).attr('data-option1') && $(value).attr('data-option2') === $(val).attr('data-option3') && $(value).attr('data-css') != 'Out of stock') {
                                    setTimeout(function() {
                                        $(val).removeAttr("disabled");
                                        $(val).removeClass('product-opt__btn_none');
                                    },200)
                                }
                            })
                        } else {

                            if ($(btn).attr('data-option1') === 'Size') {
                                let attr = $(btn).attr('data-option3');
                                if (typeof attr !== typeof undefined && attr !== false) {
                                    if($(value).attr('data-option4') === $(btn).attr('data-option1') && $(value).attr('data-option1') === $(btn).attr('data-option2') && $(value).attr('data-option2') === $(btn).attr('data-option3')) {
                                        let val = btn;
                                        $('.js-prod-item[data-id="'+ prodId +'"] .js-original-select-wrap-prod option').each(function(index,value) {
                                            if ($(value).attr('data-option3') != '-' && $(value).attr('selected') === 'selected') {
                                                removeOption(value);
                                            }
                                        })
                                        $(val).closest('ul[data-position="3"]').find('.product-opt__btn').each(function(index,btnPosition3) {
                                            if ($(btnPosition3).hasClass('product-opt__btn_active')) {
                                                $(btnPosition3).removeClass('product-opt__btn_active');
                                            }
                                            setTimeout(function() {
                                                activateAddToCart();
                                                $('.js-original-button-text-both').hide()
                                                $('.js-choose-option').show()
                                            },200)
                                        
                                        })
                                        $(val).addClass('product-opt__btn_active');
                                        $(val).attr('data-id',`${$(value).attr('value')}`);
                                        shooseOption(value);
                                        secondVariant = value;
                                        btnActive.bottomPosition3 = $(this).attr('data-option3');
                                        addTooltipVariant('css-status__bottom',value);
                                        $('.css-status__bottom').show();
                                        setTimeout(function() {
                                            actionRadioInput(value);
                                        },200)
                                    }
                                } 
                            }
                        }
                        if ($(btn).attr('data-option1') !== 'Size' && $(btn).attr('data-option4') === 'Fit') {

                        }
                    }
                });
            }

            if($(window).width() > 768) {
                if ($('.js-prod-item .js-ul-qv > .product-opt__select[value="Size"]').length == 1) {
                    let option1topNw = $('.js-ul-qv .product-opt__select[value="Size"] .product-opt__btn.product-opt__btn_active').data('option2');
                    let cssSt = $('.js-prod-item[data-id="'+ prodId +'"] .js-original-select-wrap-prod option[data-option1="'+ option1topNw +'"][data-option2="undefined"]').data('css');
                    $('.css-status-msg').text(cssSt);
                }
            } else {
                if ($('.js-ul-qv > .product-opt__select[value="Size"]').length == 1) {
                    let option1topNw = $('.js-ul-qv .product-opt__select[value="Size"] .product-opt__btn.product-opt__btn_active').data('option2');
                    let cssSt = $('.js-prod-item[data-id="'+ prodId +'"] .js-original-select-wrap-prod option[data-option1="'+ option1topNw +'"][data-option2="undefined"]').data('css');
                    $('.css-status-msg').text(cssSt);
                }
            }


            setTimeout(function() {
                if ($('body>.custom-mobile-qv-p .js-ul-qv > .product-opt__select[value="Size"]').length == 1) {

                    if ($('.js-ul-qv .product-opt_block_3').length) {
                        let option1top = $('.js-ul-qv .product-opt__select[value="Size"] .product-opt_block_1 .product-opt__btn.product-opt__btn_active').data('option2');
                        let option2top = $('.js-ul-qv .product-opt__select[value="Size"] .product-opt_block_3 .product-opt__btn.product-opt__btn_active').data('option3');
                        variantOneId = $('.js-prod-item[data-id="'+ prodId +'"] .js-original-select-wrap-prod option[data-option1="'+ option1top +'"][data-option2="'+ option2top +'"][data-option3="-"][data-option4="Size"]').data('id');
                        if (variantOneId != undefined) {
                            $('.js-quick-vr.js1').attr('data-vr', variantOneId)
                        }
                    } else {
                        let option1top = $('.js-ul-qv .product-opt__select[value="Size"] .product-opt__btn.product-opt__btn_active').data('option2');
                        variantOneId = $('.js-prod-item[data-id="'+ prodId +'"] .js-original-select-wrap-prod option[data-option1="'+ option1top +'"][data-option2="undefined"]').data('id');
    
                        if (variantOneId != undefined) {
                            $('.js-quick-vr.js1').attr('data-vr', variantOneId)
                        }
                    }
                } else {
                    let option1top = $('.js-ul-qv .product-opt__select[value="Top"] .product-opt__btn.product-opt__btn_active').data('option1');
                    let option2top = $('.js-ul-qv .product-opt__select[value="Top"] .product-opt__btn.product-opt__btn_active').data('option2');
                    variantOneId = $('.js-prod-item[data-id="'+ prodId +'"] .js-original-select-wrap-prod option[data-option1="'+ option1top +'"][data-option2="'+ option2top +'"]').data('id');
               
                    let option1bottom = $('.js-ul-qv .product-opt__select[value="Bottom"] .product-opt__btn.product-opt__btn_active').data('option1');
                    let option2bottom = $('.js-ul-qv .product-opt__select[value="Bottom"] .product-opt__btn.product-opt__btn_active').data('option2');
                    let option3bottom = $('.js-ul-qv .product-opt__select[value="Bottom"] ul[data-position="3"] .product-opt__btn.product-opt__btn_active').data('option3');
                    if($('.js-prod-item[data-id="'+ prodId +'"] .js-original-select-wrap-prod option[data-option1="'+ option1bottom +'"][data-option2="'+ option2bottom +'"]').data('option3') != '-'){
                        if (option3bottom != undefined) {
                            variantTwoId = $('.js-prod-item[data-id="'+ prodId +'"] .js-original-select-wrap-prod option[data-option1="'+ option1bottom +'"][data-option2="'+ option2bottom +'"][data-option3="'+ option3bottom +'"]').data('id');
                        }
                    } else {
                        variantTwoId = $('.js-prod-item[data-id="'+ prodId +'"] .js-original-select-wrap-prod option[data-option1="'+ option1bottom +'"][data-option2="'+ option2bottom +'"]').data('id');
                    }
                    // if (option3bottom != undefined) {
                    //     variantTwoId = $('.js-prod-item[data-id="'+ prodId +'"] .js-original-select-wrap-prod option[data-option1="'+ option1bottom +'"][data-option2="'+ option2bottom +'"][data-option3="'+ option3bottom +'"]').data('id');
                    // } else {
                    //     variantTwoId = $('.js-prod-item[data-id="'+ prodId +'"] .js-original-select-wrap-prod option[data-option1="'+ option1bottom +'"][data-option2="'+ option2bottom +'"]').data('id');
                    // }

                    
                    if (variantOneId != undefined && $('.js-ul-qv .product-opt__select[value="Top"] .product-opt__btn').hasClass('product-opt__btn_active')) {
                        $('.js-quick-vr.js1').attr('data-vr', variantOneId)
                    } else {
                        $('.js-quick-vr.js1').attr('data-vr', '')
                    }

                    if (variantTwoId != undefined && $('.js-ul-qv .product-opt__select[value="Bottom"] .product-opt__btn').hasClass('product-opt__btn_active')) {
                        $('.js-quick-vr.js2').attr('data-vr', variantTwoId)
                    } else {
                        $('.js-quick-vr.js2').attr('data-vr', '')
                    }

                    if (variantOneId != undefined) {

                    }
                }

            },300)


            setTimeout(function() {
                if($('.product-opt__btn').hasClass('product-opt__btn_active')) {
                    let variantId = '';
                    let product_handle = $('#quick-view').attr("class");

                    $('.js-original-select-wrap .js-quick-vr').each(function() {
                        if(!!$(this).attr('data-vr')) {
                            variantId = $(this).attr('data-vr');
                        }
                    });
                
                    $.getJSON(`/products/${product_handle}.js`, function (product) {
                        let variantArr = product.variants.filter( item => +item.id === +variantId );
                        let variant = variantArr[0];
                        
                        if (variant !== undefined) {
                            if((variant.compare_at_price - variant.price)/variant.compare_at_price >= 0.4 ) {
                                $('.css-status').each(function() {
                                    if(!$(this).hasClass('m-hide-css')) {
                                        if(!$(this).find('.product-opt__final-sale').length) {
                                            $(this).append(`<div class="product-opt__final-sale">Item is Final Sale. No return/exchange allowed.</div>`);
                                            $('.js-quick-vr[data-vr="'+ variantId +'"]').attr('data-fs', '')
                                            $('.js-quick-vr[data-vr="'+ variantId +'"]').addClass('fs')
                                        }
                                    } else {
                                        if($(this).find('.product-opt__final-sale').length) {
                                            $(this).find('.product-opt__final-sale').remove();
                                            $('.js-quick-vr[data-vr="'+ variantId +'"]').removeAttr('data-fs')
                                            $('.js-quick-vr[data-vr="'+ variantId +'"]').removeClass('fs')
                                        }
                                    }
    
                                });
                            }
                        }
                    })
                } else {
                    $('.product-opt__final-sale').remove();
                }
            },300)

           if ($('.product-option-set').hasClass('js-group')) {
                    setTimeout(function() {
                        if ($('.product-opt__btn[data-option1="Top"]').hasClass('product-opt__btn_active') && !$('.product-opt__btn[data-option1="Bottom"]').hasClass('product-opt__btn_active')) {
                            $('.js-original-button-text-top').text('SOLD AS SET: Please Select Bottom')
                        }
                        if (!$('.product-opt__btn[data-option1="Top"]').hasClass('product-opt__btn_active') && $('.product-opt__btn[data-option1="Bottom"]').hasClass('product-opt__btn_active')) {
                            $('.js-original-button-text-bottom').text('SOLD AS SET: Please Select Top')
                        }
                    }, 500)
                    setTimeout(function() {
                        if ($('.product-opt__btn[data-option1="Top"]').hasClass('product-opt__btn_active') && $('.product-opt__btn[data-option1="Bottom"]').hasClass('product-opt__btn_active')) {
                            $('.product-single__form .btn.add-to-cart').removeClass('m-select-sz')
                        } else if ($('.product-opt__btn[data-option1="Size"]').hasClass('product-opt__btn_active')) {
                            $('.product-single__form .btn.add-to-cart').removeClass('m-select-sz')
                        } else {
                            $('.product-single__form .btn.add-to-cart').addClass('m-select-sz')
                        }
                    },200)
              }

            setTimeout(function() {
                if ($('.js-ul-qv .css-status__bottom .css-status-msg').text() == 'Out of stock') {
                    $(".qv-add-button").addClass('m-select-sz')
                }
            },200)

        });
        
        // FENSONS: READ MORE
        $(document).ready(function() {
          $('.rm').click(function() {
            $(this).toggleClass('rmexpanded');
          });
        });
        // END FENSONS: READ MORE

        // ADA: keyboard activation (Enter/Space) for QV button
        $(document).on('keydown', '.js-quick-add-cst:not(.m-ds-disabled)', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                $(this).trigger('click');
            }
        });

        $(document).on('click', '.js-quick-add-cst:not(.m-ds-disabled)', function(e) {
            e.stopPropagation();
            e.preventDefault();
            var $qvTrigger = $(this); // ADA: store trigger for focus return
            if($(window).width() > 768) {
                $('.js-quick-add-cst').addClass('m-ds-disabled');
                $('.qv-add-button').addClass('m-select-sz')

                $('.js-original-button-text-top, .js-original-button-text-bottom, .js-original-button-text-both').hide();

                $('.js-choose-option').show();

                let productId = $(this).closest('.js-prod-item').attr('data-id');

                let productHandle = $(this).closest('.grid-product__content').find('.js-handle').attr('data-handle') + '/';

                let allProdVariants = $(this).closest('.js-prod-item').find('.js-available-variants').find('.js-option-cst'),
                    handle = $(this).attr('data-handle');

                let postdata = [];
                allProdVariants.each(function(){
                    var id = $(this).attr('data-variant-id');
                    var css = $(this).attr('data-variant-css');
                    postdata.push({id: id, css_rule: css});
                });

                let result = [];

                $.each(postdata, function(i, item) {
                    if (item.css_rule != ' ') {
                        var matchingItems = $.grep(result, function (i) {
                            return i.id === item.id && i.key === item.key;
                        });
                        if (matchingItems.length === 0){
                            result.push(item);
                        }
                        return item;
                    }
                });

                $('.custom-mobile-qv-p').attr('data-prod-id', productId);
                $('.custom-mobile-qv-p').attr('data-handle', productHandle);
                $('.js-original-select-wrap').attr('data-handle', productHandle);
                $('.custom-mobile-qv-p').show();
                $(this).closest('.js-prod-item').addClass('m-selected');
                quickView(handle, productId)

                $(this).closest('.js-prod-item').find('.grid-product__image-mask').append($('body>.custom-mobile-qv-p').clone());
                var $qvDialog = $('.grid__item.m-selected').find('.custom-mobile-qv-p');
                // ADA: mark cloned panel as dialog
                $qvDialog.attr({
                    'role': 'dialog',
                    'aria-modal': 'true',
                    'aria-label': $qvTrigger.attr('aria-label') || 'Quick view'
                });
                $('.grid__item.m-selected').find('.qv-content').addClass('m-show');

                // ADA: move focus into QV after render
                setTimeout(function() {
                    var $focusable = $qvDialog.find('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])').first();
                    if ($focusable.length) { $focusable.focus(); }
                }, 150);

                function removeQv() {
                    $('.grid__item.m-selected').find('.qv-content').removeClass('m-show');
                    // ADA: return focus to trigger
                    setTimeout(function() { $qvTrigger.focus(); }, 110);
                    setTimeout(function() {
                        $('.grid__item.m-selected .custom-mobile-qv-p').remove();
                        $( ".grid__item.m-selected" ).off();
                        $(".grid__item.m-selected").removeClass('m-selected');
                        firstVariant = '-';
                        secondVariant = '-';
                        $('.js-quick-add-cst').removeClass('m-ds-disabled');
                        $(document).off('keydown.qvEscape keydown.qvTrap');
                    },100);
                }

                // ADA: Escape key closes QV
                $(document).on('keydown.qvEscape', function(e) {
                    if (e.key === 'Escape') {
                        removeQv();
                    }
                });

                // ADA: focus trap — keep Tab cycling within QV
                $(document).on('keydown.qvTrap', function(e) {
                    if (e.key !== 'Tab') return;
                    var $focusableItems = $qvDialog.find('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])').filter(':visible');
                    if (!$focusableItems.length) return;
                    var $first = $focusableItems.first();
                    var $last = $focusableItems.last();
                    if (e.shiftKey) {
                        if ($(document.activeElement).is($first)) {
                            e.preventDefault();
                            $last.focus();
                        }
                    } else {
                        if ($(document.activeElement).is($last)) {
                            e.preventDefault();
                            $first.focus();
                        }
                    }
                });

                $('.grid__item.m-selected').mouseleave(function(){
                    if(!$('.size-popup').is(':visible')) {
                        removeQv();
                    } else {
                        $(document).on('click', '.close', function() {
                            setTimeout(function() {
                                $(document).on('mousemove', function(e) {
                                    if (!$('.grid__item.m-selected:hover').length) {
                                        removeQv()
                                        $(document).off('mousemove');
                                    } else {
                                        $('.grid__item.m-selected').mouseleave(function() {
                                            removeQv()
                                            $(document).off('mousemove');
                                        })
                                    }
                                });
                                $('.size-popup>div').remove();
                            },1000)
                        });
                
                        $(document).mouseup(function (e) {
                            if ($(e.target).closest(".size-popup").length
                            === 0 && $('.size-popup').is(':visible')) {
                                setTimeout(function() {
                                    $(document).on('mousemove', function(e) {
                                        if (!$('.grid__item.m-selected:hover').length) {
                                            removeQv();
                                            $(document).off('mousemove');
                                        } else {
                                            $('.grid__item.m-selected').mouseleave(function() {
                                                removeQv();
                                                $(document).off('mousemove');
                                            })
                                        }
                                      });
                                      $('.size-popup>div').remove();
                                },1000)
                            }
                        });
                    }
                });

            } else {
                $('.qv-add-button').addClass('m-select-sz')

                $('.js-original-button-text-top, .js-original-button-text-bottom, .js-original-button-text-both').hide();
    
                $('.js-choose-option').show();
    
                let productId = $(this).closest('.js-prod-item').attr('data-id');
    
                let productHandle = $(this).closest('.grid-product__content').find('.js-handle').attr('data-handle') + '/';
    
                let allProdVariants = $(this).closest('.js-prod-item').find('.js-available-variants').find('.js-option-cst'),
                    handle = $(this).attr('data-handle');
    
                let postdata = [];
                allProdVariants.each(function(){
                    var id = $(this).attr('data-variant-id');
                    var css = $(this).attr('data-variant-css');
                    postdata.push({id: id, css_rule: css});
                });
    
                let result = [];
    
                $.each(postdata, function(i, item) {
                    if (item.css_rule != ' ') {
                        var matchingItems = $.grep(result, function (i) {
                            return i.id === item.id && i.key === item.key;
                        });
                        if (matchingItems.length === 0){
                            result.push(item);
                        }
                        return item;
                    }
                });
    
                $('.custom-mobile-qv-p').attr('data-prod-id', productId);
                $('.custom-mobile-qv-p').attr('data-handle', productHandle);
                $('.js-original-select-wrap').attr('data-handle', productHandle);
                $('.custom-mobile-qv-p').show();
                $('.js-prod-item').addClass('m-dis-selected');
                $(this).closest('.js-prod-item').addClass('m-selected');
                $(this).closest('.js-prod-item').removeClass('m-dis-selected');
                quickView(handle, productId)
                
                let offSetMargin = 42;
                if ($('body').hasClass('four-per-row')) {
                  offSetMargin = 82
                }

                if ($('body').hasClass("boost-pfs-filter-tree-open-body")) {
                   offSetMargin = 82
                }
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(this).closest('.js-prod-item').offset().top - offSetMargin
                }, 700);
            }
        });

        $(document).on("click", ".qv-add-button", function (e) {
            e.preventDefault(); // QV panel sits inside the card's <a>; don't navigate
            var qty = 1;
            var selectedOptions = '';
            var var_id = '';
            var product_handle = $('.js-original-select-wrap').attr('data-handle');
            let items = [];
            let currentBtn = $(this);
            let uniqNubmerLine = 0;
            if (currentBtn.closest('.qv-add-to-cart').find('.js-ul-qv').hasClass('js-group')) {
                let randowubmerLine = Math.floor(Math.random() * 16 * 2 + 3),
                prodIdLine = $('.custom-mobile-qv-p').data('prod-id');
                uniqNubmerLine = randowubmerLine + prodIdLine;
            }


            $('body>.custom-mobile-qv-p .js-quick-vr').each(function (i) {
                let id = $(this).attr('data-vr');
                let currentVar = $(this);
                let properObject = 'Item is Final Sale. No return/exchange allowed.';
                let dataCss ='';
                let dataGlobalName = '';
                let dataShipsFromCountry = '';
                var isUs = $('.product-single__form .js-form-intl-ddu, .qv-add-to-cart .js-form-intl-ddu').first().attr('data-currency') === 'USD';
                var hasTag = $('.product-single__form .js-form-intl-ddu, .qv-add-to-cart .js-form-intl-ddu').first().attr('data-intl-ddu') === 'true';
                $('.js-original-select-wrap-prod option').each(function() {
                    if(+($(this).attr('data-id')) === +id) {
                        dataCss = $(this).attr('data-css');
                        dataGlobalName = $(this).attr('data-global-name');
                        var shipsFrom = $(this).attr('data-ships-from-country');
                        var invQ = parseInt($(this).attr('data-inventory-quantity') || '0', 10);
                        dataShipsFromCountry = (isUs && hasTag && shipsFrom && invQ < 1) ? ('Ships from ' + shipsFrom + '. May be subject to customs/tariffs.') : '';
                    }
                });

                if (currentVar.hasClass('fs')) {
                   
                    if (id != '' && id != undefined && !currentBtn.closest('.qv-add-to-cart').find('.js-ul-qv').hasClass('js-group')) {
                        items.push({
                            quantity:1, 
                            id:id,
                            properties: {
                                FinalSale: properObject,
                                Status: dataCss,
                                Name: dataGlobalName,
                                Note: dataShipsFromCountry || ''
                            }
                        });
                    } else if (id != '' && id != undefined && currentBtn.closest('.qv-add-to-cart').find('.js-ul-qv').hasClass('js-group')) {
                        items.push({
                            quantity:1, 
                            id:id,
                            properties: { "GroupSold":  uniqNubmerLine, FinalSale: properObject, Status: dataCss, Name: dataGlobalName, Note: dataShipsFromCountry || ''}
                        });
                    }
                } else {
                    if (id != '' && id != undefined && !currentBtn.closest('.qv-add-to-cart').find('.js-ul-qv').hasClass('js-group')) {
                        items.push({
                            quantity:1, 
                            id:id,
                            properties: {
                                Status: dataCss,
                                Name: dataGlobalName,
                                Note: dataShipsFromCountry || ''
                            }
                        });
                    } else if (id != '' && id != undefined && currentBtn.closest('.qv-add-to-cart').find('.js-ul-qv').hasClass('js-group')) {
                        items.push({
                            quantity:1, 
                            id:id,
                            properties: { "GroupSold":  uniqNubmerLine, properObject, Status: dataCss, Name: dataGlobalName, Note: dataShipsFromCountry || ''}
                        });
                    }
                }
            });
            $('.js-quick-vr.js1').removeAttr('data-vr');
            $('.js-quick-vr.js2').removeAttr('data-vr');
            $('.js-quick-vr.js3').removeAttr('data-vr');

            processCart();
            function processCart() {
                $.ajax({
                    url: '/cart/add.js',
                    dataType: 'json',
                    type: 'post',
                    data: { items: items },
                    success: function (info) {
                        variantOneId = '';
                        variantTwoId = '';
                        $('.js-ul-qv li').remove();
                        $('.custom-mobile-qv-p').hide();
                        $('.js-quick-vr.js1').removeAttr('data-vr');
                        $('.js-quick-vr.js2').removeAttr('data-vr');
                        $('.js-quick-vr.js3').removeAttr('data-vr');
                        items = [];
                        $('.js-cart-trigger').trigger('click');
                        setTimeout(function() {
                            firstVariant = '-';
                            secondVariant = '-';
                        },500)
                        $.getJSON('/cart.js', function(cart) {
                            $('.cart-link__bubble').text(cart.items.length);
                        });
                    },
                    error: function (XMLHttpRequest) {
                        var data = eval('(' + XMLHttpRequest.responseText + ')');
                        var response = data.description;
                        var status = XMLHttpRequest.status;
                        if (status === 422) {
                            
                        } else {
                            
                        }
                        variantOneId = '';
                        variantTwoId = '';
                        $('.js-ul-qv li').remove();
                        $('.custom-mobile-qv-p').hide();
                        $('.js-quick-vr.js1').removeAttr('data-vr');
                        $('.js-quick-vr.js2').removeAttr('data-vr');
                        $('.js-quick-vr.js3').removeAttr('data-vr');
                        items = [];
                        setTimeout(function() {
                            // location.reload();
                        },1500)
                    }
                });
            }
        });
        

        $(document).on('click', '.qv-product-title', function(e) {
            $('.product-opt__btn_active').trigger('click');
            $('.custom-mobile-qv-p').hide();
            variantOneId = '';
            variantTwoId = '';
            $('.js-quick-vr.js1').removeAttr('data-vr');
            $('.js-quick-vr.js2').removeAttr('data-vr');
            $('.js-quick-vr.js3').removeAttr('data-vr');
            $('.js-prod-item').removeClass('m-selected m-dis-selected');
            // Rescue body-panel tooltip wrap BEFORE the options list is wiped.
            // addTooltipVariant moves it into a css-status <li>; if we don't pull
            // it out first, $('.js-ul-qv li').remove() below destroys it permanently.
            var $bodyTw = $('body>.custom-mobile-qv-p .qv-tooltip-wrap');
            if ($bodyTw.length) {
                $bodyTw.find('.js-tooltip').addClass('m-tool-hide');
                $('body>.custom-mobile-qv-p .js-original-select-wrap').before($bodyTw);
            }
            $('.js-ul-qv li').remove();
            $('.js-original-button-text-top, .js-original-button-text-bottom, .js-original-button-text-both').remove()
            $('body').removeClass('qv-loaded');
            $('.js-ul-qv').removeClass('product-option-set js-group')
            $('.qv-product-options .tooltip').remove();
        });

        $(document).on('click', '.size-fit-guide.qv', function(e) {
            e.preventDefault();
            let vendorProd = $('.qv-product-size').attr('data-vendor');
            fetch(window.Shopify.routes.root + "?sections=size-chart-"+ vendorProd +"")
            .then((res) => {
                return res.json();
            })
            .then((data) => {
                let html = $.parseHTML(data[Object.keys(data)[0]])
                $(".size-popup").empty();
                $(".size-popup").append(html);
                $('.size-popup').show();
                $('body').addClass('m-submenu-opened m-pu-size');
                $('.size-chart-table table').each(function() {
                  if ($(window).width() < 769) {
                     $(this).wrap('<div class="scrollable-table-container"></div>');
                  }
                });
            })
        });

        $(document).on('click', '.template-collection .size-chart .close, .template-search .size-chart .close', function(e) {
            $('#newsletter-footer , .size-popup').hide();
            $('body').removeClass('m-submenu-opened m-pu-size');
        });
        
        // FENSONS: Checks links under Collection title and adds a class to any that match current URL
        $(document).ready(function(){
          // Get the current page URL without any query parameters or hashes
          var currentPage = window.location.href.split(/[?#]/)[0];
          
          // Iterate over each link in the '.collection-description-links' block
          $('.collection-description-links a').each(function(){
            // Check if the href of the link is the same as the current page's URL
            if (this.href === currentPage) {
              // If it is, add the 'link-active' class to the <a> element
              $(this).addClass('link-active');
            }
          });
        });
        // END Fensons
        
        
        // FENSONS: Get images height on Collections page, and set TOP position of the Wishlish HEARTS button
        $(document).ready(function () {
            function adjustElementPositions(containerSelector, imageSelector, targetSelector, offset = 0) {
                $(containerSelector).each(function () {
                    var $image = $(this).find(imageSelector);
                    var $target = $(this).find(targetSelector);
        
                    // Check if both the image and target element exist
                    if ($image.length && $target.length) {
                        var imageHeight = $image.height(); // Get the height of the image
                        if (imageHeight) {
                            $target.css('top', (imageHeight - offset) + 'px'); // Set target's top position
                        }
                    }
                });
            }
        
            // Define your elements and offsets
            const elementsToAdjust = [
                { container: '.grid__item', image: '.grid-product__image', target: '.wishlist_btn', offset: 20 },   // setting the location of the HEARTS Wishlist icon
                { container: '.grid__item', image: '.grid-product__image', target: '.js-quick-add-cst', offset: 30 }  // setting the QV + button location
            ];
        
            // Function to adjust all defined elements
            function adjustAllPositions() {
                elementsToAdjust.forEach(config => {
                    adjustElementPositions(config.container, config.image, config.target, config.offset);
                });
            }
        
            // Run once when the page is initially loaded
            adjustAllPositions();
        
            // Observe DOM changes for dynamic rendering by Boost Commerce
            const observer = new MutationObserver(function () {
                adjustAllPositions();
            });
        
            // Observe changes to the body or specific container
            observer.observe(document.body, { childList: true, subtree: true });
        });
        // END FENSONS


        if (window.location.href.indexOf("variant") > -1) {
          let urlVariant = $(location).attr("href")
          idVariant = urlVariant.split('variant=')

          $('.product-single__variants option').each(function(index,value) {
            if($(value).attr('value') === idVariant[1]) {
              $('.product-opt__select').each(function(index,select) {
                if($(select).attr('value') === $(value).attr('data-option1')) {
                  $(`.product-opt__select[value='${$(value).attr('data-option1')}'] .product-opt__input`).each(function(index,radioInput) {
                    if($(value).attr('data-option1') === $(radioInput).attr('value')){
                      $(radioInput).trigger('click');
                      $(radioInput).prev().trigger('click');
                    }
                    if($(value).attr('data-option2') === $(radioInput).attr('value')){
                      $(radioInput).trigger('click');
                      $(radioInput).prev().trigger('click');
                    }
                    if($(value).attr('data-option3') === $(radioInput).attr('value')){
                      $(radioInput).trigger('click');
                      $(radioInput).prev().trigger('click');
                    }
                    if($(value).attr('data-option3') === '-' && $(radioInput).attr('data-index') === 'option3'){
                      $(radioInput).trigger('click');
                    }
                  });
                  setTimeout(function() {
                    if($(select).find('.css-status').hasClass('css-status__top')) {
                      addTooltipVariant('css-status__top',value);
                    }

                    if($(select).find('.css-status').hasClass('css-status__bottom')) {
                      addTooltipVariant('css-status__bottom',value);
                    }
                  },3000)
                }
              })
            }
          });
        }
      
      	function moveDownKlarna() {
            if($('.swym-button-bar').length && $(window).width() < 768) {
                if($('.klarna_down').hasClass('klarna_hide')) {
                    // $('.klarna_down').appendTo('.product-single__form');
                    $('.klarna_down').removeClass('klarna_hide');
                }
            }
            setTimeout(function() {
                moveDownKlarna();
            },2000)
        }
        setTimeout(function() {
            moveDownKlarna();
        },2000)

        function updateTopQuickAdd() {          // QV Quickview script
            if($(window).width() > 768) {
                setTimeout(function() {
                    let tempHeightVar = 20;
                    if ($('body').hasClass('four-per-row')) {
                      tempHeightVar = 50;
                    }
                    // Button now lives inside .grid-product__image-mask and is
                    // anchored via CSS bottom:0 — just make it visible
                    $('.js-prod-item .js-quick-add-cst').each(function() {
                        $(this).css({'opacity': 1});
                    });
                    $('.m-btn-wrap').each(function() {
                        if(!$(this).hasClass('m-show'))
                        $(this).addClass('m-show');
                    });
                },100)
            }
        }

        updateTopQuickAdd();

        $(window).resize(function() {
            updateTopQuickAdd();
        });
        
        // FENSONS: Designer Index
        $(document).ready(function() {
            // Show all brand blocks on page load
            $(".brand-block").show();
            
            $(".letter").click(function() {
                var selectedLetter = $(this).text();
                
                // Escape special characters in IDs (like 0-9)
                var safeLetter = selectedLetter.replace("-", "\\-");
                
                // Show all blocks if "ALL" is selected
                if (selectedLetter === "ALL") {
                    $(".brand-block").fadeIn(200);
                } else {
                    // Otherwise, hide all and show only the selected block
                    $(".brand-block").hide();
                    var selectedBlock = $("#brand-block-" + safeLetter);
                    if (selectedBlock.length) {
                        selectedBlock.fadeIn(200);
                    }
                }
                
                // Update selected letter styling
                $(".letter").removeClass("selected");
                $(this).addClass("selected");
            });
        });
        
        
        // FENSONS: Countdown Timer Plugin for Shopify
        (function($) {
          $.fn.countdownTimer = function(options) {
            var settings = $.extend({
              targetDate: '',
              startDate: null,
              design: 't3b',
              message: '',
              messageColor: null,
              messageFontSize: null,       // NEW: Font size for message
              messageMargin: null,          // NEW: Margin for message
              messagePosition: null,        // NEW: Position - 'top', 'left', 'right', 'bottom'
              serverTime: new Date().getTime(),
              hideParent: false,
              hideMobile: false,
              labelDays: 'Days',
              labelHours: 'Hours',
              labelMinutes: 'Mins',
              labelSeconds: 'Secs',
              gap: null,
              unitBgColor: null,
              digitColor: null,
              labelColor: null,
              digitFontSize: null,
              labelFontSize: null,
              digitLabelMargin: null,
              position: null,
              unitPadding: null,
              unitDirection: 'vertical',
              hideDaysUnder24hrs: false,
              sessionMinutes: 0,            // per-visitor timer length: minutes (116) or 'H:MM:SS' ('1:13:34'). Starts on first view, never shows again in that browser once done
              sessionKey: 'default'         // change per promo to give everyone a fresh timer
            }, options);
            
            return this.each(function() {
              var $container = $(this);
              
              var sessionMs = 0;
              if (typeof settings.sessionMinutes === 'string' && settings.sessionMinutes.indexOf(':') > -1) {
                var hms = settings.sessionMinutes.split(':').reverse();   // [s, m, h]
                sessionMs = ((parseInt(hms[2], 10) || 0) * 3600 + (parseInt(hms[1], 10) || 0) * 60 + (parseInt(hms[0], 10) || 0)) * 1000;
              } else {
                sessionMs = (parseFloat(settings.sessionMinutes) || 0) * 60000;
              }
              
              if (!settings.targetDate && !sessionMs) {
                return;
              }
              
              if (settings.hideMobile && $(window).width() <= 768) {
                $container.hide();
                return;
              }
              
              // CHECK IF EXPIRED FIRST - BEFORE building any HTML
              var clientTime = new Date().getTime();
              var timeOffset = settings.serverTime - clientTime;
              var now = new Date().getTime() + timeOffset;
              var targetDate = settings.targetDate ? new Date(settings.targetDate).getTime() : Infinity;
              
              // Per-visitor timer: first-seen timestamp in localStorage (sessionStorage gets wiped on load on this site).
              // Only stamped once the promo window (startDate) is open; targetDate, if set, still caps it.
              if (sessionMs) {
                var sessionStoreKey = 'sw_promo_timer_' + settings.sessionKey;
                var started = null;
                try { started = parseInt(localStorage.getItem(sessionStoreKey), 10) || null; } catch (e) {}
                var windowOpen = !settings.startDate || now >= new Date(settings.startDate).getTime();
                if (!started && windowOpen) {
                  started = now;
                  try { localStorage.setItem(sessionStoreKey, String(started)); } catch (e) {}
                }
                if (started) {
                  targetDate = Math.min(targetDate, started + sessionMs);
                }
              }
              var distance = targetDate - now;
              
              // Check if timer should start showing yet
              if (settings.startDate !== null && settings.startDate !== '') {
                var startDate = new Date(settings.startDate).getTime();
                if (now < startDate) {
                  // Not time to show yet - hide and return
                  if (settings.hideParent) {
                    $container.parent().hide();
                  } else {
                    $container.hide();
                  }
                  return;
                }
              }
              
              if (distance < 0) {
                // Timer already expired - hide parent or container
                if (settings.hideParent) {
                  $container.parent().hide();
                } else {
                  $container.hide();
                }
                return;
              }
              
              // Timer is valid - show the parent wrapper if hideParent is true
              if (settings.hideParent) {
                $container.parent().addClass('timer-active');
              }
              
              var messageHtml = settings.message ? '<div class="message">' + settings.message + '</div>' : '';
              var uniqueId = $container.attr('id') || 'countdown-' + Math.random().toString(36).substr(2, 9);
              $container.attr('id', uniqueId);
              
              // Determine message position in HTML structure
              var messageTop = (settings.messagePosition === 'top') ? messageHtml : '';
              var messageLeft = (settings.messagePosition === 'left') ? messageHtml : '';
              var messageRight = (settings.messagePosition === 'right') ? messageHtml : '';
              var messageBottom = (settings.messagePosition === 'bottom') ? messageHtml : '';
              var messageDefault = (!settings.messagePosition || settings.messagePosition === 'left') ? messageHtml : '';
              
              var html = '<div class="countdown-wrapper">' +
                '<div class="countdown-timer ' + settings.design + '">' +
                  messageTop +
                  '<div class="countdown-display" role="timer" aria-live="polite" aria-atomic="true">' +
                    messageDefault +
                    '<div class="time-unit time-unit-days" aria-label="Days remaining">' +
                      '<span class="time-value" id="days-' + uniqueId + '" aria-label="Days">00</span>' +
                      '<span class="time-label">' + settings.labelDays + '</span>' +
                    '</div>' +
                    '<div class="time-unit" aria-label="Hours remaining">' +
                      '<span class="time-value" id="hours-' + uniqueId + '" aria-label="Hours">00</span>' +
                      '<span class="time-label">' + settings.labelHours + '</span>' +
                    '</div>' +
                    '<div class="time-unit" aria-label="Minutes remaining">' +
                      '<span class="time-value" id="minutes-' + uniqueId + '" aria-label="Minutes">00</span>' +
                      '<span class="time-label">' + settings.labelMinutes + '</span>' +
                    '</div>' +
                    '<div class="time-unit" aria-label="Seconds remaining">' +
                      '<span class="time-value" id="seconds-' + uniqueId + '" aria-label="Seconds">00</span>' +
                      '<span class="time-label">' + settings.labelSeconds + '</span>' +
                    '</div>' +
                    messageRight +
                  '</div>' +
                  messageBottom +
                '</div>' +
              '</div>';
              
              $container.html(html);
              
              // Timer is valid, add class to show it
              $container.addClass('timer-active');
              
              // Apply custom styling if provided
              var $countdownTimer = $container.find('.countdown-timer');
              var $countdownDisplay = $container.find('.countdown-display');
              var $timeUnits = $container.find('.time-unit');
              var $timeUnitDays = $container.find('.time-unit-days');
              var $timeValues = $container.find('.time-value');
              var $timeLabels = $container.find('.time-label');
              var $message = $container.find('.message');
              
              if (settings.gap !== null && settings.gap !== '') {
                $countdownDisplay.css('gap', settings.gap);
              }
              
              if (settings.unitBgColor !== null && settings.unitBgColor !== '') {
                $timeUnits.css('background-color', settings.unitBgColor);
              }
              
              if (settings.unitPadding !== null && settings.unitPadding !== '') {
                $timeUnits.css('padding', settings.unitPadding);
              }
              
              if (settings.digitColor !== null && settings.digitColor !== '') {
                $timeValues.css('color', settings.digitColor);
              }
              
              if (settings.labelColor !== null && settings.labelColor !== '') {
                $timeLabels.css('color', settings.labelColor);
              }
              
              // Apply message color
              if (settings.messageColor !== null && settings.messageColor !== '') {
                $message.css('color', settings.messageColor);
              }
              
              // Apply message font size
              if (settings.messageFontSize !== null && settings.messageFontSize !== '') {
                $message.css('font-size', settings.messageFontSize);
              }
              
              // Apply message margin
              if (settings.messageMargin !== null && settings.messageMargin !== '') {
                $message.css('margin', settings.messageMargin);
              }
              
              // Apply font size for .time-value (the numbers: 00, 01, 02...)
              if (settings.digitFontSize !== null && settings.digitFontSize !== '') {
                $timeValues.css('font-size', settings.digitFontSize);
              }
              
              // Apply font size for .time-label (the text: Days, Hrs, Mins, Secs)
              if (settings.labelFontSize !== null && settings.labelFontSize !== '') {
                $timeLabels.css('font-size', settings.labelFontSize);
              }
              
              // Apply unit direction (vertical or horizontal) and adjust margin accordingly
              if (settings.unitDirection === 'horizontal' || settings.unitDirection === 'row') {
                $timeUnits.css('flex-direction', 'row');
                
                // For horizontal layout, apply margin-left: margin: top right bottom left
                if (settings.digitLabelMargin !== null && settings.digitLabelMargin !== '') {
                  $timeLabels.css('margin', '0 0 0 ' + settings.digitLabelMargin);
                }
              } else {
                $timeUnits.css('flex-direction', 'column');
                
                // For vertical layout, apply margin-top: margin: top right bottom left
                if (settings.digitLabelMargin !== null && settings.digitLabelMargin !== '') {
                  $timeLabels.css('margin', settings.digitLabelMargin + ' 0 0 0');
                }
              }
              
              if (settings.position !== null && settings.position !== '') {
                $container.css('position', 'absolute');
                
                var positionLower = settings.position.toLowerCase().trim();
                
                if (positionLower === 'top left') {
                  $container.css({'top': '0', 'left': '0'});
                } else if (positionLower === 'top center') {
                  $container.css({'top': '0', 'left': '50%', 'transform': 'translateX(-50%)'});
                } else if (positionLower === 'top right') {
                  $container.css({'top': '0', 'right': '0'});
                } else if (positionLower === 'center left') {
                  $container.css({'top': '50%', 'left': '0', 'transform': 'translateY(-50%)'});
                } else if (positionLower === 'center' || positionLower === 'center center') {
                  $container.css({'top': '50%', 'left': '50%', 'transform': 'translate(-50%, -50%)'});
                } else if (positionLower === 'center right') {
                  $container.css({'top': '50%', 'right': '0', 'transform': 'translateY(-50%)'});
                } else if (positionLower === 'bottom left') {
                  $container.css({'bottom': '0', 'left': '0'});
                } else if (positionLower === 'bottom center') {
                  $container.css({'bottom': '0', 'left': '50%', 'transform': 'translateX(-50%)'});
                } else if (positionLower === 'bottom right') {
                  $container.css({'bottom': '0', 'right': '0'});
                } else {
                  var positionParts = settings.position.trim().split(/\s+/);
                  
                  if (positionParts.length === 2) {
                    $container.css({'top': positionParts[0], 'left': positionParts[1]});
                  } else if (positionParts.length === 4) {
                    $container.css({
                      'top': positionParts[0],
                      'right': positionParts[1],
                      'bottom': positionParts[2],
                      'left': positionParts[3]
                    });
                  } else {
                    $container.css('top', settings.position);
                  }
                }
              }
              
              function updateCountdown() {
                var now = new Date().getTime() + timeOffset;
                var distance = targetDate - now;
                
                if (distance < 0) {
                  // Remove the timer-active class first
                  $container.removeClass('timer-active');
                  
                  if (settings.hideParent) {
                    $container.parent().removeClass('timer-active');
                    // Wait for transition to complete before hiding
                    setTimeout(function() {
                      $container.parent().hide();
                    }, 300);
                  } else {
                    // Wait for transition to complete before hiding
                    setTimeout(function() {
                      $container.hide();
                    }, 300);
                  }
                  
                  clearInterval(countdownInterval);
                  return;
                }
                
                var days = Math.floor(distance / (1000 * 60 * 60 * 24));
                var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                var seconds = Math.floor((distance % (1000 * 60)) / 1000);
                
                // Handle hiding days column when less than 24 hours
                if (settings.hideDaysUnder24hrs) {
                  if (distance < (24 * 60 * 60 * 1000)) {
                    // Less than 24 hours remaining - hide days
                    $timeUnitDays.hide();
                  } else {
                    // 24+ hours remaining - show days
                    $timeUnitDays.show();
                  }
                }
                
                $('#days-' + uniqueId).text(String(days).padStart(2, '0'));
                $('#hours-' + uniqueId).text(String(hours).padStart(2, '0'));
                $('#minutes-' + uniqueId).text(String(minutes).padStart(2, '0'));
                $('#seconds-' + uniqueId).text(String(seconds).padStart(2, '0'));
              }
              
              updateCountdown();
              var countdownInterval = setInterval(updateCountdown, 1000);
              
              if (settings.hideMobile) {
                $(window).on('resize', function() {
                  if ($(window).width() <= 768) {
                    $container.hide();
                  } else {
                    $container.show();
                  }
                });
              }
            });
          };
        })(jQuery);
        // END FENSONS: Countdown Timer Plugin for Shopify
        
    });
})(jQuery);